/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.6.0 (NJsonSchema v10.0.28.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { saveAs } from 'file-saver';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
	private http: HttpClient;
	private baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
		this.http = http;
		this.baseUrl = baseUrl ? baseUrl : "https://localhost:44332";
	}

	dashboard_GetDashboard(): Observable<DashboardDto> {
		let url_ = this.baseUrl + "/api/Dashboard";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processDashboard_GetDashboard(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processDashboard_GetDashboard(<any>response_);
				} catch (e) {
					return <Observable<DashboardDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<DashboardDto>><any>_observableThrow(response_);
		}));
	}

	protected processDashboard_GetDashboard(response: HttpResponseBase): Observable<DashboardDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = DashboardDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<DashboardDto>(<any>null);
	}

	establecimientos_GetEstablecimientos(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfEstablecimientoExtendedDto> {
		let url_ = this.baseUrl + "/api/Establecimientos?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_GetEstablecimientos(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_GetEstablecimientos(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfEstablecimientoExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfEstablecimientoExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_GetEstablecimientos(response: HttpResponseBase): Observable<PagedResultOfEstablecimientoExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfEstablecimientoExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfEstablecimientoExtendedDto>(<any>null);
	}

	establecimientos_PostEstablecimiento(establecimiento: EstablecimientoDto): Observable<EstablecimientoExtendedDto> {
		let url_ = this.baseUrl + "/api/Establecimientos";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(establecimiento);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_PostEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_PostEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_PostEstablecimiento(response: HttpResponseBase): Observable<EstablecimientoExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = EstablecimientoExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<EstablecimientoExtendedDto>(<any>null);
	}

	establecimientos_SearchEstablecimiento(nombreEstablecimiento: string | null | undefined, showAll: boolean | undefined): Observable<GenericItemDto[]> {
		let url_ = this.baseUrl + "/api/Establecimientos/Search?";
		if (nombreEstablecimiento !== undefined)
			url_ += "nombreEstablecimiento=" + encodeURIComponent("" + nombreEstablecimiento) + "&";
		if (showAll === null)
			throw new Error("The parameter 'showAll' cannot be null.");
		else if (showAll !== undefined)
			url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_SearchEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_SearchEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<GenericItemDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<GenericItemDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_SearchEstablecimiento(response: HttpResponseBase): Observable<GenericItemDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(GenericItemDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GenericItemDto[]>(<any>null);
	}

	establecimientos_GetUsuariosByEstablecimientoId(establecimientoIdQuery: number | undefined, establecimientoIdPath: string): Observable<UsuarioExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Establecimientos/{establecimientoId}/Usuarios?";
		if (establecimientoIdPath === undefined || establecimientoIdPath === null)
			throw new Error("The parameter 'establecimientoIdPath' must be defined.");
		url_ = url_.replace("{establecimientoId}", encodeURIComponent("" + establecimientoIdPath));
		if (establecimientoIdQuery === null)
			throw new Error("The parameter 'establecimientoIdQuery' cannot be null.");
		else if (establecimientoIdQuery !== undefined)
			url_ += "establecimientoId=" + encodeURIComponent("" + establecimientoIdQuery) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_GetUsuariosByEstablecimientoId(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_GetUsuariosByEstablecimientoId(<any>response_);
				} catch (e) {
					return <Observable<UsuarioExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<UsuarioExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_GetUsuariosByEstablecimientoId(response: HttpResponseBase): Observable<UsuarioExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(UsuarioExtendedDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<UsuarioExtendedDto[]>(<any>null);
	}

	establecimientos_GetEstablecimiento(id: number): Observable<EstablecimientoExtendedDto> {
		let url_ = this.baseUrl + "/api/Establecimientos/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_GetEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_GetEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_GetEstablecimiento(response: HttpResponseBase): Observable<EstablecimientoExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = EstablecimientoExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<EstablecimientoExtendedDto>(<any>null);
	}

	establecimientos_PutEstablecimiento(id: number, establecimiento: EstablecimientoDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Establecimientos/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(establecimiento);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_PutEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_PutEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_PutEstablecimiento(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	establecimientos_DeleteEstablecimiento(id: number): Observable<EstablecimientoExtendedDto> {
		let url_ = this.baseUrl + "/api/Establecimientos/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_DeleteEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_DeleteEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<EstablecimientoExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_DeleteEstablecimiento(response: HttpResponseBase): Observable<EstablecimientoExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = EstablecimientoExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<EstablecimientoExtendedDto>(<any>null);
	}

	establecimientos_PatchEstablecimiento(id: number, establecimiento: EstablecimientoDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Establecimientos/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(establecimiento);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_PatchEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_PatchEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_PatchEstablecimiento(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	establecimientos_GetEstablecimientosOptions(): Observable<EstablecimientoOptionDto> {
		let url_ = this.baseUrl + "/api/Establecimientos/Options";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processEstablecimientos_GetEstablecimientosOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processEstablecimientos_GetEstablecimientosOptions(<any>response_);
				} catch (e) {
					return <Observable<EstablecimientoOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<EstablecimientoOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processEstablecimientos_GetEstablecimientosOptions(response: HttpResponseBase): Observable<EstablecimientoOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = EstablecimientoOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<EstablecimientoOptionDto>(<any>null);
	}

	formularios_GetFormularios(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfFormularioExtendedDto> {
		let url_ = this.baseUrl + "/api/Formularios?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_GetFormularios(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_GetFormularios(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfFormularioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfFormularioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_GetFormularios(response: HttpResponseBase): Observable<PagedResultOfFormularioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfFormularioExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfFormularioExtendedDto>(<any>null);
	}

	formularios_PostFormulario(formulario: FormularioDto): Observable<FormularioExtendedDto> {
		let url_ = this.baseUrl + "/api/Formularios";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(formulario);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_PostFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_PostFormulario(<any>response_);
				} catch (e) {
					return <Observable<FormularioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<FormularioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_PostFormulario(response: HttpResponseBase): Observable<FormularioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = FormularioExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<FormularioExtendedDto>(<any>null);
	}

	formularios_GetFormulario(id: number): Observable<FormularioExtendedDto> {
		let url_ = this.baseUrl + "/api/Formularios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_GetFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_GetFormulario(<any>response_);
				} catch (e) {
					return <Observable<FormularioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<FormularioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_GetFormulario(response: HttpResponseBase): Observable<FormularioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = FormularioExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<FormularioExtendedDto>(<any>null);
	}

	formularios_PutFormulario(id: number, formulario: FormularioDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Formularios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(formulario);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_PutFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_PutFormulario(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_PutFormulario(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	formularios_DeleteFormulario(id: number): Observable<FormularioExtendedDto> {
		let url_ = this.baseUrl + "/api/Formularios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_DeleteFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_DeleteFormulario(<any>response_);
				} catch (e) {
					return <Observable<FormularioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<FormularioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_DeleteFormulario(response: HttpResponseBase): Observable<FormularioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = FormularioExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<FormularioExtendedDto>(<any>null);
	}

	formularios_GetFormulariosOptions(): Observable<FormularioOptionDto> {
		let url_ = this.baseUrl + "/api/Formularios/Options";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_GetFormulariosOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_GetFormulariosOptions(<any>response_);
				} catch (e) {
					return <Observable<FormularioOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<FormularioOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_GetFormulariosOptions(response: HttpResponseBase): Observable<FormularioOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = FormularioOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<FormularioOptionDto>(<any>null);
	}

	formularios_GetPreguntasFormulario(formularioId: number): Observable<PreguntaExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Formularios/{formularioId}/Preguntas";
		if (formularioId === undefined || formularioId === null)
			throw new Error("The parameter 'formularioId' must be defined.");
		url_ = url_.replace("{formularioId}", encodeURIComponent("" + formularioId));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_GetPreguntasFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_GetPreguntasFormulario(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_GetPreguntasFormulario(response: HttpResponseBase): Observable<PreguntaExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(PreguntaExtendedDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto[]>(<any>null);
	}

	formularios_PostPreguntasFormulario(formularioId: number, preguntaIds: number[]): Observable<PreguntaExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Formularios/{formularioId}/Preguntas";
		if (formularioId === undefined || formularioId === null)
			throw new Error("The parameter 'formularioId' must be defined.");
		url_ = url_.replace("{formularioId}", encodeURIComponent("" + formularioId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(preguntaIds);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_PostPreguntasFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_PostPreguntasFormulario(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_PostPreguntasFormulario(response: HttpResponseBase): Observable<PreguntaExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData201)) {
					result201 = [] as any;
					for (let item of resultData201)
						result201!.push(PreguntaExtendedDto.fromJS(item));
				}
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto[]>(<any>null);
	}

	formularios_DeletePreguntasFormulario(formularioId: number, preguntaIds: number[]): Observable<PreguntaExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Formularios/{formularioId}/Preguntas";
		if (formularioId === undefined || formularioId === null)
			throw new Error("The parameter 'formularioId' must be defined.");
		url_ = url_.replace("{formularioId}", encodeURIComponent("" + formularioId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(preguntaIds);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processFormularios_DeletePreguntasFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processFormularios_DeletePreguntasFormulario(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processFormularios_DeletePreguntasFormulario(response: HttpResponseBase): Observable<PreguntaExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(PreguntaExtendedDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto[]>(<any>null);
	}

	formularios_ExportFormulario(formularioId: number, tituloFormulario: string, desdeFecha: string | null | undefined, hastaFecha: string | null | undefined, nivelAtencion: NivelAtencion | null | undefined, provincia: Provincia | null | undefined, municipio: Municipio | null | undefined, establecimientoId: number | null | undefined, tipoServicio: number | null | undefined, tipoSolicitud: number | null | undefined, regionSalud: RegionSalud | null | undefined, usuarioId: string | null | undefined): Observable<void> {
		let url_ = this.baseUrl + "/api/Formularios/excel/{formularioId}?";
		if (formularioId === undefined || formularioId === null)
			throw new Error("The parameter 'formularioId' must be defined.");
		url_ = url_.replace("{formularioId}", encodeURIComponent("" + formularioId));
		if (desdeFecha !== undefined)
			url_ += "desdeFecha=" + encodeURIComponent(desdeFecha) + "&";
		if (hastaFecha !== undefined)
			url_ += "hastaFecha=" + encodeURIComponent(hastaFecha) + "&";
		if (nivelAtencion !== undefined)
			url_ += "nivelAtencion=" + encodeURIComponent("" + nivelAtencion) + "&";
		if (provincia !== undefined)
			url_ += "provincia=" + encodeURIComponent("" + provincia) + "&";
		if (municipio !== undefined)
			url_ += "municipio=" + encodeURIComponent("" + municipio) + "&";
		if (establecimientoId !== undefined)
			url_ += "establecimientoId=" + encodeURIComponent("" + establecimientoId) + "&";
		if (tipoServicio !== undefined)
			url_ += "tipoServicio=" + encodeURIComponent("" + tipoServicio) + "&";
		if (tipoSolicitud !== undefined)
			url_ += "tipoSolicitud=" + encodeURIComponent("" + tipoSolicitud) + "&";
		if (regionSalud !== undefined)
			url_ += "regionSalud=" + encodeURIComponent("" + regionSalud) + "&";
		if (usuarioId !== undefined)
			url_ += "usuarioId=" + encodeURIComponent("" + usuarioId) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "body",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		const filename = desdeFecha.slice(0, 10) === hastaFecha.slice(0, 10)
			? `Reporte ${tituloFormulario} ${desdeFecha.slice(0, 10)}.xlsx`
			: `Reporte ${tituloFormulario} ${desdeFecha.slice(0, 10)} - ${hastaFecha.slice(0, 10)}.xlsx`

		this.http.get(url_, options_).subscribe(res => {
			saveAs(res, filename);
		});

		return _observableOf<void>();
	}

	gruposOpciones_GetGruposOpciones(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfGrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/GruposOpciones?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_GetGruposOpciones(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_GetGruposOpciones(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfGrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfGrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_GetGruposOpciones(response: HttpResponseBase): Observable<PagedResultOfGrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfGrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfGrupoOpcionExtendedDto>(<any>null);
	}

	gruposOpciones_PostGrupoOpcion(grupoOpcion: GrupoOpcionDto): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/GruposOpciones";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(grupoOpcion);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_PostGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_PostGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_PostGrupoOpcion(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = GrupoOpcionExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	gruposOpciones_GetGrupoOpcion(id: number): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_GetGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_GetGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_GetGrupoOpcion(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = GrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	gruposOpciones_PutGrupoOpcion(id: number, grupoOpcion: GrupoOpcionDto): Observable<void> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(grupoOpcion);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_PutGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_PutGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_PutGrupoOpcion(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	gruposOpciones_DeleteGrupoOpcion(id: number): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_DeleteGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_DeleteGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_DeleteGrupoOpcion(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = GrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	gruposOpciones_GetOpcionesGrupoOpcion(grupoOpcionId: number): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{grupoOpcionId}/Opciones";
		if (grupoOpcionId === undefined || grupoOpcionId === null)
			throw new Error("The parameter 'grupoOpcionId' must be defined.");
		url_ = url_.replace("{grupoOpcionId}", encodeURIComponent("" + grupoOpcionId));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_GetOpcionesGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_GetOpcionesGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_GetOpcionesGrupoOpcion(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = GrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	gruposOpciones_PatchOpcionesGrupoOpcion(grupoOpcionId: number, opcionOrdenDtos: OpcionOrdenDto[]): Observable<void> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{grupoOpcionId}/Opciones";
		if (grupoOpcionId === undefined || grupoOpcionId === null)
			throw new Error("The parameter 'grupoOpcionId' must be defined.");
		url_ = url_.replace("{grupoOpcionId}", encodeURIComponent("" + grupoOpcionId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(opcionOrdenDtos);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_PatchOpcionesGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_PatchOpcionesGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_PatchOpcionesGrupoOpcion(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	gruposOpciones_PostOpcionesGrupoOpcion(grupoOpcionId: number, opcionOrdenDtos: OpcionOrdenDto[]): Observable<OpcionExtendedDto[]> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{grupoOpcionId}/Opciones";
		if (grupoOpcionId === undefined || grupoOpcionId === null)
			throw new Error("The parameter 'grupoOpcionId' must be defined.");
		url_ = url_.replace("{grupoOpcionId}", encodeURIComponent("" + grupoOpcionId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(opcionOrdenDtos);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_PostOpcionesGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_PostOpcionesGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<OpcionExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<OpcionExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_PostOpcionesGrupoOpcion(response: HttpResponseBase): Observable<OpcionExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData201)) {
					result201 = [] as any;
					for (let item of resultData201)
						result201!.push(OpcionExtendedDto.fromJS(item));
				}
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<OpcionExtendedDto[]>(<any>null);
	}

	gruposOpciones_DeleteOpcionesGrupoOpcion(grupoOpcionId: number, opcionesId: number[]): Observable<OpcionExtendedDto[]> {
		let url_ = this.baseUrl + "/api/GruposOpciones/{grupoOpcionId}/Opciones";
		if (grupoOpcionId === undefined || grupoOpcionId === null)
			throw new Error("The parameter 'grupoOpcionId' must be defined.");
		url_ = url_.replace("{grupoOpcionId}", encodeURIComponent("" + grupoOpcionId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(opcionesId);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processGruposOpciones_DeleteOpcionesGrupoOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processGruposOpciones_DeleteOpcionesGrupoOpcion(<any>response_);
				} catch (e) {
					return <Observable<OpcionExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<OpcionExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processGruposOpciones_DeleteOpcionesGrupoOpcion(response: HttpResponseBase): Observable<OpcionExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(OpcionExtendedDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<OpcionExtendedDto[]>(<any>null);
	}

	opciones_GetOpciones(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfOpcionDto> {
		let url_ = this.baseUrl + "/api/Opciones?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processOpciones_GetOpciones(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processOpciones_GetOpciones(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfOpcionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfOpcionDto>><any>_observableThrow(response_);
		}));
	}

	protected processOpciones_GetOpciones(response: HttpResponseBase): Observable<PagedResultOfOpcionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfOpcionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfOpcionDto>(<any>null);
	}

	opciones_PostOpcion(opcion: OpcionDto): Observable<OpcionDto> {
		let url_ = this.baseUrl + "/api/Opciones";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(opcion);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processOpciones_PostOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processOpciones_PostOpcion(<any>response_);
				} catch (e) {
					return <Observable<OpcionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<OpcionDto>><any>_observableThrow(response_);
		}));
	}

	protected processOpciones_PostOpcion(response: HttpResponseBase): Observable<OpcionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = OpcionDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<OpcionDto>(<any>null);
	}

	opciones_GetOpcion(id: number): Observable<OpcionDto> {
		let url_ = this.baseUrl + "/api/Opciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processOpciones_GetOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processOpciones_GetOpcion(<any>response_);
				} catch (e) {
					return <Observable<OpcionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<OpcionDto>><any>_observableThrow(response_);
		}));
	}

	protected processOpciones_GetOpcion(response: HttpResponseBase): Observable<OpcionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = OpcionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<OpcionDto>(<any>null);
	}

	opciones_PutOpcion(id: number, opcion: OpcionDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Opciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(opcion);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processOpciones_PutOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processOpciones_PutOpcion(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processOpciones_PutOpcion(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	opciones_DeleteOpcion(id: number): Observable<OpcionDto> {
		let url_ = this.baseUrl + "/api/Opciones/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processOpciones_DeleteOpcion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processOpciones_DeleteOpcion(<any>response_);
				} catch (e) {
					return <Observable<OpcionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<OpcionDto>><any>_observableThrow(response_);
		}));
	}

	protected processOpciones_DeleteOpcion(response: HttpResponseBase): Observable<OpcionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = OpcionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<OpcionDto>(<any>null);
	}

	preguntas_GetPreguntas(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfPreguntaExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_GetPreguntas(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_GetPreguntas(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfPreguntaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfPreguntaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_GetPreguntas(response: HttpResponseBase): Observable<PagedResultOfPreguntaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfPreguntaExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfPreguntaExtendedDto>(<any>null);
	}

	preguntas_PostPregunta(pregunta: PreguntaDto): Observable<PreguntaExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(pregunta);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_PostPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_PostPregunta(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_PostPregunta(response: HttpResponseBase): Observable<PreguntaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = PreguntaExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto>(<any>null);
	}

	preguntas_GetPregunta(id: number): Observable<PreguntaExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_GetPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_GetPregunta(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_GetPregunta(response: HttpResponseBase): Observable<PreguntaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PreguntaExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto>(<any>null);
	}

	preguntas_PutPregunta(id: number, pregunta: PreguntaDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Preguntas/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(pregunta);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_PutPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_PutPregunta(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_PutPregunta(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	preguntas_DeletePregunta(id: number): Observable<PreguntaExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_DeletePregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_DeletePregunta(<any>response_);
				} catch (e) {
					return <Observable<PreguntaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_DeletePregunta(response: HttpResponseBase): Observable<PreguntaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PreguntaExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaExtendedDto>(<any>null);
	}

	preguntas_GetPreguntasOptions(): Observable<PreguntaOptionDto> {
		let url_ = this.baseUrl + "/api/Preguntas/Options";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_GetPreguntasOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_GetPreguntasOptions(<any>response_);
				} catch (e) {
					return <Observable<PreguntaOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PreguntaOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_GetPreguntasOptions(response: HttpResponseBase): Observable<PreguntaOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PreguntaOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PreguntaOptionDto>(<any>null);
	}

	preguntas_GetGrupoOpcionPregunta(preguntaId: number): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas/{preguntaId}/GrupoOpcion";
		if (preguntaId === undefined || preguntaId === null)
			throw new Error("The parameter 'preguntaId' must be defined.");
		url_ = url_.replace("{preguntaId}", encodeURIComponent("" + preguntaId));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_GetGrupoOpcionPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_GetGrupoOpcionPregunta(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_GetGrupoOpcionPregunta(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = GrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("A server side error occurred.", status, _responseText, _headers);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	preguntas_PostGrupoOpcionPregunta(preguntaId: number, grupoOpcion: GrupoOpcionDto): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas/{preguntaId}/GrupoOpcion";
		if (preguntaId === undefined || preguntaId === null)
			throw new Error("The parameter 'preguntaId' must be defined.");
		url_ = url_.replace("{preguntaId}", encodeURIComponent("" + preguntaId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(grupoOpcion);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_PostGrupoOpcionPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_PostGrupoOpcionPregunta(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_PostGrupoOpcionPregunta(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = GrupoOpcionExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	preguntas_DeleteGrupoOpcionPregunta(preguntaId: number): Observable<GrupoOpcionExtendedDto> {
		let url_ = this.baseUrl + "/api/Preguntas/{preguntaId}/GrupoOpcion";
		if (preguntaId === undefined || preguntaId === null)
			throw new Error("The parameter 'preguntaId' must be defined.");
		url_ = url_.replace("{preguntaId}", encodeURIComponent("" + preguntaId));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processPreguntas_DeleteGrupoOpcionPregunta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processPreguntas_DeleteGrupoOpcionPregunta(<any>response_);
				} catch (e) {
					return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<GrupoOpcionExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processPreguntas_DeleteGrupoOpcionPregunta(response: HttpResponseBase): Observable<GrupoOpcionExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = GrupoOpcionExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<GrupoOpcionExtendedDto>(<any>null);
	}

	reportes_GetReporteSatisfaccion(filters: string | null | undefined): Observable<ReporteSatisfaccionDto> {
		let url_ = this.baseUrl + "/api/Reportes/NivelSatisfaccion?";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processReportes_GetReporteSatisfaccion(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processReportes_GetReporteSatisfaccion(<any>response_);
				} catch (e) {
					return <Observable<ReporteSatisfaccionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<ReporteSatisfaccionDto>><any>_observableThrow(response_);
		}));
	}

	protected processReportes_GetReporteSatisfaccion(response: HttpResponseBase): Observable<ReporteSatisfaccionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = ReporteSatisfaccionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<ReporteSatisfaccionDto>(<any>null);
	}

	reportes_GetReporteEstablecimiento(filters: string | null | undefined): Observable<ReporteEstablecimientoDto> {
		let url_ = this.baseUrl + "/api/Reportes/Establecimiento?";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processReportes_GetReporteEstablecimiento(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processReportes_GetReporteEstablecimiento(<any>response_);
				} catch (e) {
					return <Observable<ReporteEstablecimientoDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<ReporteEstablecimientoDto>><any>_observableThrow(response_);
		}));
	}

	protected processReportes_GetReporteEstablecimiento(response: HttpResponseBase): Observable<ReporteEstablecimientoDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = ReporteEstablecimientoDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<ReporteEstablecimientoDto>(<any>null);
	}

	reportes_GetReporteFormulario(filters: string | null | undefined): Observable<ReporteFormularioDto> {
		let url_ = this.baseUrl + "/api/Reportes/Formulario?";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processReportes_GetReporteFormulario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processReportes_GetReporteFormulario(<any>response_);
				} catch (e) {
					return <Observable<ReporteFormularioDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<ReporteFormularioDto>><any>_observableThrow(response_);
		}));
	}

	protected processReportes_GetReporteFormulario(response: HttpResponseBase): Observable<ReporteFormularioDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = ReporteFormularioDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<ReporteFormularioDto>(<any>null);
	}

	reportes_GetReportesOptions(formularioId: number | null | undefined): Observable<ReporteOptionDto> {
		let url_ = this.baseUrl + "/api/Reportes/Options?";
		if (formularioId !== undefined)
			url_ += "formularioId=" + encodeURIComponent("" + formularioId) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processReportes_GetReportesOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processReportes_GetReportesOptions(<any>response_);
				} catch (e) {
					return <Observable<ReporteOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<ReporteOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processReportes_GetReportesOptions(response: HttpResponseBase): Observable<ReporteOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = ReporteOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<ReporteOptionDto>(<any>null);
	}

	respuestas_GetRespuestas(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfRespuestaExtendedDto> {
		let url_ = this.baseUrl + "/api/Respuestas?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_GetRespuestas(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_GetRespuestas(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfRespuestaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfRespuestaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_GetRespuestas(response: HttpResponseBase): Observable<PagedResultOfRespuestaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfRespuestaExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfRespuestaExtendedDto>(<any>null);
	}

	respuestas_PostRespuesta(respuesta: RespuestaFlatDto): Observable<RespuestaExtendedDto> {
		let url_ = this.baseUrl + "/api/Respuestas";
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(respuesta);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_PostRespuesta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_PostRespuesta(<any>response_);
				} catch (e) {
					return <Observable<RespuestaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<RespuestaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_PostRespuesta(response: HttpResponseBase): Observable<RespuestaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result201 = RespuestaExtendedDto.fromJS(resultData201);
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<RespuestaExtendedDto>(<any>null);
	}

	respuestas_GetRespuesta(id: number): Observable<RespuestaExtendedDto> {
		let url_ = this.baseUrl + "/api/Respuestas/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_GetRespuesta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_GetRespuesta(<any>response_);
				} catch (e) {
					return <Observable<RespuestaExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<RespuestaExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_GetRespuesta(response: HttpResponseBase): Observable<RespuestaExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = RespuestaExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<RespuestaExtendedDto>(<any>null);
	}

	respuestas_GetSeguimientosRespuesta(respuestaId: number, seguimientoRespuesta: SeguimientoRespuestaDto): Observable<SeguimientoRespuestaExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Respuestas/{respuestaId}/Seguimientos";
		if (respuestaId === undefined || respuestaId === null)
			throw new Error("The parameter 'respuestaId' must be defined.");
		url_ = url_.replace("{respuestaId}", encodeURIComponent("" + respuestaId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(seguimientoRespuesta);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_GetSeguimientosRespuesta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_GetSeguimientosRespuesta(<any>response_);
				} catch (e) {
					return <Observable<SeguimientoRespuestaExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<SeguimientoRespuestaExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_GetSeguimientosRespuesta(response: HttpResponseBase): Observable<SeguimientoRespuestaExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData200)) {
					result200 = [] as any;
					for (let item of resultData200)
						result200!.push(SeguimientoRespuestaExtendedDto.fromJS(item));
				}
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<SeguimientoRespuestaExtendedDto[]>(<any>null);
	}

	respuestas_PostSeguimientoRespuesta(respuestaId: number, seguimientoRespuesta: SeguimientoRespuestaDto): Observable<SeguimientoRespuestaExtendedDto[]> {
		let url_ = this.baseUrl + "/api/Respuestas/{respuestaId}/Seguimientos";
		if (respuestaId === undefined || respuestaId === null)
			throw new Error("The parameter 'respuestaId' must be defined.");
		url_ = url_.replace("{respuestaId}", encodeURIComponent("" + respuestaId));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(seguimientoRespuesta);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				"Accept": "application/json"
			})
		};

		return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_PostSeguimientoRespuesta(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_PostSeguimientoRespuesta(<any>response_);
				} catch (e) {
					return <Observable<SeguimientoRespuestaExtendedDto[]>><any>_observableThrow(e);
				}
			} else
				return <Observable<SeguimientoRespuestaExtendedDto[]>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_PostSeguimientoRespuesta(response: HttpResponseBase): Observable<SeguimientoRespuestaExtendedDto[]> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 201) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result201: any = null;
				let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				if (Array.isArray(resultData201)) {
					result201 = [] as any;
					for (let item of resultData201)
						result201!.push(SeguimientoRespuestaExtendedDto.fromJS(item));
				}
				return _observableOf(result201);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<SeguimientoRespuestaExtendedDto[]>(<any>null);
	}

	respuestas_GetRespuestaOptions(formularioId: number | null | undefined): Observable<RespuestaOptionDto> {
		let url_ = this.baseUrl + "/api/Respuestas/Options?";
		if (formularioId !== undefined)
			url_ += "formularioId=" + encodeURIComponent("" + formularioId) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRespuestas_GetRespuestaOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRespuestas_GetRespuestaOptions(<any>response_);
				} catch (e) {
					return <Observable<RespuestaOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<RespuestaOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processRespuestas_GetRespuestaOptions(response: HttpResponseBase): Observable<RespuestaOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = RespuestaOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<RespuestaOptionDto>(<any>null);
	}

	roles_GetRoles(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfRolCountDto> {
		let url_ = this.baseUrl + "/api/Roles?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRoles_GetRoles(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRoles_GetRoles(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfRolCountDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfRolCountDto>><any>_observableThrow(response_);
		}));
	}

	protected processRoles_GetRoles(response: HttpResponseBase): Observable<PagedResultOfRolCountDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfRolCountDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfRolCountDto>(<any>null);
	}

	roles_GetRol(id: string): Observable<RolCountDto> {
		let url_ = this.baseUrl + "/api/Roles/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processRoles_GetRol(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processRoles_GetRol(<any>response_);
				} catch (e) {
					return <Observable<RolCountDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<RolCountDto>><any>_observableThrow(response_);
		}));
	}

	protected processRoles_GetRol(response: HttpResponseBase): Observable<RolCountDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = RolCountDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<RolCountDto>(<any>null);
	}

	usuarios_GetUsuarios(page: number | undefined, pageSize: number | undefined, filters: string | null | undefined, sortOrder: string | null | undefined): Observable<PagedResultOfUsuarioExtendedDto> {
		let url_ = this.baseUrl + "/api/Usuarios?";
		if (page === null)
			throw new Error("The parameter 'page' cannot be null.");
		else if (page !== undefined)
			url_ += "page=" + encodeURIComponent("" + page) + "&";
		if (pageSize === null)
			throw new Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined)
			url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
		if (filters !== undefined)
			url_ += "filters=" + encodeURIComponent("" + filters) + "&";
		if (sortOrder !== undefined)
			url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processUsuarios_GetUsuarios(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processUsuarios_GetUsuarios(<any>response_);
				} catch (e) {
					return <Observable<PagedResultOfUsuarioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<PagedResultOfUsuarioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processUsuarios_GetUsuarios(response: HttpResponseBase): Observable<PagedResultOfUsuarioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = PagedResultOfUsuarioExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<PagedResultOfUsuarioExtendedDto>(<any>null);
	}

	usuarios_GetUsuario(id: string): Observable<UsuarioExtendedDto> {
		let url_ = this.baseUrl + "/api/Usuarios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processUsuarios_GetUsuario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processUsuarios_GetUsuario(<any>response_);
				} catch (e) {
					return <Observable<UsuarioExtendedDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<UsuarioExtendedDto>><any>_observableThrow(response_);
		}));
	}

	protected processUsuarios_GetUsuario(response: HttpResponseBase): Observable<UsuarioExtendedDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = UsuarioExtendedDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<UsuarioExtendedDto>(<any>null);
	}

	usuarios_PutUsuario(id: string, usuario: UsuarioDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Usuarios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(usuario);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processUsuarios_PutUsuario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processUsuarios_PutUsuario(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processUsuarios_PutUsuario(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	usuarios_PatchUsuario(id: string, usuario: UsuarioDto): Observable<void> {
		let url_ = this.baseUrl + "/api/Usuarios/{id}";
		if (id === undefined || id === null)
			throw new Error("The parameter 'id' must be defined.");
		url_ = url_.replace("{id}", encodeURIComponent("" + id));
		url_ = url_.replace(/[?&]$/, "");

		const content_ = JSON.stringify(usuario);

		let options_: any = {
			body: content_,
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			})
		};

		return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processUsuarios_PatchUsuario(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processUsuarios_PatchUsuario(<any>response_);
				} catch (e) {
					return <Observable<void>><any>_observableThrow(e);
				}
			} else
				return <Observable<void>><any>_observableThrow(response_);
		}));
	}

	protected processUsuarios_PatchUsuario(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return _observableOf<void>(<any>null);
			}));
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result400: any = null;
				let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result400 = ProblemDetails.fromJS(resultData400);
				return throwException("A server side error occurred.", status, _responseText, _headers, result400);
			}));
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result404: any = null;
				let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result404 = ProblemDetails.fromJS(resultData404);
				return throwException("A server side error occurred.", status, _responseText, _headers, result404);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<void>(<any>null);
	}

	usuarios_GetUsuariosOptions(): Observable<UsuarioOptionDto> {
		let url_ = this.baseUrl + "/api/Usuarios/Options";
		url_ = url_.replace(/[?&]$/, "");

		let options_: any = {
			observe: "response",
			responseType: "blob",
			headers: new HttpHeaders({
				"Accept": "application/json"
			})
		};

		return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
			return this.processUsuarios_GetUsuariosOptions(response_);
		})).pipe(_observableCatch((response_: any) => {
			if (response_ instanceof HttpResponseBase) {
				try {
					return this.processUsuarios_GetUsuariosOptions(<any>response_);
				} catch (e) {
					return <Observable<UsuarioOptionDto>><any>_observableThrow(e);
				}
			} else
				return <Observable<UsuarioOptionDto>><any>_observableThrow(response_);
		}));
	}

	protected processUsuarios_GetUsuariosOptions(response: HttpResponseBase): Observable<UsuarioOptionDto> {
		const status = response.status;
		const responseBlob =
			response instanceof HttpResponse ? response.body :
				(<any>response).error instanceof Blob ? (<any>response).error : undefined;

		let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
		if (status === 200) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				let result200: any = null;
				let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
				result200 = UsuarioOptionDto.fromJS(resultData200);
				return _observableOf(result200);
			}));
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
				return throwException("An unexpected server error occurred.", status, _responseText, _headers);
			}));
		}
		return _observableOf<UsuarioOptionDto>(<any>null);
	}
}

export class DashboardDto implements IDashboardDto {
	totalEntregas!: number;
	totalEntregasMesActual!: number;
	totalEntregasSemanaActual!: number;
	tiposFormularios!: number;
	misEstablecimientos!: number;
	generalSatisfaction!: number;
	customerSatisfaction!: number;
	generalSatisfactionSeries?: { [key: string]: SeriesDtoOfDecimal[]; } | undefined;
	customerSatisfactionSeries?: { [key: string]: SeriesDtoOfDecimal[]; } | undefined;
	entregasFormulariosSeries?: { [key: string]: SeriesDtoOfLong[]; } | undefined;

	constructor(data?: IDashboardDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.totalEntregas = _data["totalEntregas"];
			this.totalEntregasMesActual = _data["totalEntregasMesActual"];
			this.totalEntregasSemanaActual = _data["totalEntregasSemanaActual"];
			this.tiposFormularios = _data["tiposFormularios"];
			this.misEstablecimientos = _data["misEstablecimientos"];
			this.generalSatisfaction = _data["generalSatisfaction"];
			this.customerSatisfaction = _data["customerSatisfaction"];
			if (_data["generalSatisfactionSeries"]) {
				this.generalSatisfactionSeries = {} as any;
				for (let key in _data["generalSatisfactionSeries"]) {
					if (_data["generalSatisfactionSeries"].hasOwnProperty(key))
						this.generalSatisfactionSeries![key] = _data["generalSatisfactionSeries"][key] ? _data["generalSatisfactionSeries"][key].map((i: any) => SeriesDtoOfDecimal.fromJS(i)) : [];
				}
			}
			if (_data["customerSatisfactionSeries"]) {
				this.customerSatisfactionSeries = {} as any;
				for (let key in _data["customerSatisfactionSeries"]) {
					if (_data["customerSatisfactionSeries"].hasOwnProperty(key))
						this.customerSatisfactionSeries![key] = _data["customerSatisfactionSeries"][key] ? _data["customerSatisfactionSeries"][key].map((i: any) => SeriesDtoOfDecimal.fromJS(i)) : [];
				}
			}
			if (_data["entregasFormulariosSeries"]) {
				this.entregasFormulariosSeries = {} as any;
				for (let key in _data["entregasFormulariosSeries"]) {
					if (_data["entregasFormulariosSeries"].hasOwnProperty(key))
						this.entregasFormulariosSeries![key] = _data["entregasFormulariosSeries"][key] ? _data["entregasFormulariosSeries"][key].map((i: any) => SeriesDtoOfLong.fromJS(i)) : [];
				}
			}
		}
	}

	static fromJS(data: any): DashboardDto {
		data = typeof data === 'object' ? data : {};
		let result = new DashboardDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["totalEntregas"] = this.totalEntregas;
		data["totalEntregasMesActual"] = this.totalEntregasMesActual;
		data["totalEntregasSemanaActual"] = this.totalEntregasSemanaActual;
		data["tiposFormularios"] = this.tiposFormularios;
		data["misEstablecimientos"] = this.misEstablecimientos;
		data["generalSatisfaction"] = this.generalSatisfaction;
		data["customerSatisfaction"] = this.customerSatisfaction;
		if (this.generalSatisfactionSeries) {
			data["generalSatisfactionSeries"] = {};
			for (let key in this.generalSatisfactionSeries) {
				if (this.generalSatisfactionSeries.hasOwnProperty(key))
					data["generalSatisfactionSeries"][key] = this.generalSatisfactionSeries[key];
			}
		}
		if (this.customerSatisfactionSeries) {
			data["customerSatisfactionSeries"] = {};
			for (let key in this.customerSatisfactionSeries) {
				if (this.customerSatisfactionSeries.hasOwnProperty(key))
					data["customerSatisfactionSeries"][key] = this.customerSatisfactionSeries[key];
			}
		}
		if (this.entregasFormulariosSeries) {
			data["entregasFormulariosSeries"] = {};
			for (let key in this.entregasFormulariosSeries) {
				if (this.entregasFormulariosSeries.hasOwnProperty(key))
					data["entregasFormulariosSeries"][key] = this.entregasFormulariosSeries[key];
			}
		}
		return data;
	}
}

export interface IDashboardDto {
	totalEntregas: number;
	totalEntregasMesActual: number;
	totalEntregasSemanaActual: number;
	tiposFormularios: number;
	misEstablecimientos: number;
	generalSatisfaction: number;
	customerSatisfaction: number;
	generalSatisfactionSeries?: { [key: string]: SeriesDtoOfDecimal[]; } | undefined;
	customerSatisfactionSeries?: { [key: string]: SeriesDtoOfDecimal[]; } | undefined;
	entregasFormulariosSeries?: { [key: string]: SeriesDtoOfLong[]; } | undefined;
}

export class SeriesDtoOfDecimal implements ISeriesDtoOfDecimal {
	data?: number[] | undefined;
	label?: string | undefined;

	constructor(data?: ISeriesDtoOfDecimal) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["data"])) {
				this.data = [] as any;
				for (let item of _data["data"])
					this.data!.push(item);
			}
			this.label = _data["label"];
		}
	}

	static fromJS(data: any): SeriesDtoOfDecimal {
		data = typeof data === 'object' ? data : {};
		let result = new SeriesDtoOfDecimal();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.data)) {
			data["data"] = [];
			for (let item of this.data)
				data["data"].push(item);
		}
		data["label"] = this.label;
		return data;
	}
}

export interface ISeriesDtoOfDecimal {
	data?: number[] | undefined;
	label?: string | undefined;
}

export class SeriesDtoOfLong implements ISeriesDtoOfLong {
	data?: number[] | undefined;
	label?: string | undefined;

	constructor(data?: ISeriesDtoOfLong) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["data"])) {
				this.data = [] as any;
				for (let item of _data["data"])
					this.data!.push(item);
			}
			this.label = _data["label"];
		}
	}

	static fromJS(data: any): SeriesDtoOfLong {
		data = typeof data === 'object' ? data : {};
		let result = new SeriesDtoOfLong();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.data)) {
			data["data"] = [];
			for (let item of this.data)
				data["data"].push(item);
		}
		data["label"] = this.label;
		return data;
	}
}

export interface ISeriesDtoOfLong {
	data?: number[] | undefined;
	label?: string | undefined;
}

export abstract class PagedResultBase implements IPagedResultBase {
	currentPage!: number;
	pageCount!: number;
	pageSize!: number;
	rowCount!: number;
	firstRowOnPage!: number;
	lastRowOnPage!: number;
	filters?: { [key: string]: any; } | undefined;
	sortOrder?: { [key: string]: any; } | undefined;

	constructor(data?: IPagedResultBase) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.currentPage = _data["currentPage"];
			this.pageCount = _data["pageCount"];
			this.pageSize = _data["pageSize"];
			this.rowCount = _data["rowCount"];
			this.firstRowOnPage = _data["firstRowOnPage"];
			this.lastRowOnPage = _data["lastRowOnPage"];
			if (_data["filters"]) {
				this.filters = {} as any;
				for (let key in _data["filters"]) {
					if (_data["filters"].hasOwnProperty(key))
						this.filters![key] = _data["filters"][key];
				}
			}
			if (_data["sortOrder"]) {
				this.sortOrder = {} as any;
				for (let key in _data["sortOrder"]) {
					if (_data["sortOrder"].hasOwnProperty(key))
						this.sortOrder![key] = _data["sortOrder"][key];
				}
			}
		}
	}

	static fromJS(data: any): PagedResultBase {
		data = typeof data === 'object' ? data : {};
		throw new Error("The abstract class 'PagedResultBase' cannot be instantiated.");
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["currentPage"] = this.currentPage;
		data["pageCount"] = this.pageCount;
		data["pageSize"] = this.pageSize;
		data["rowCount"] = this.rowCount;
		data["firstRowOnPage"] = this.firstRowOnPage;
		data["lastRowOnPage"] = this.lastRowOnPage;
		if (this.filters) {
			data["filters"] = {};
			for (let key in this.filters) {
				if (this.filters.hasOwnProperty(key))
					data["filters"][key] = this.filters[key];
			}
		}
		if (this.sortOrder) {
			data["sortOrder"] = {};
			for (let key in this.sortOrder) {
				if (this.sortOrder.hasOwnProperty(key))
					data["sortOrder"][key] = this.sortOrder[key];
			}
		}
		return data;
	}
}

export interface IPagedResultBase {
	currentPage: number;
	pageCount: number;
	pageSize: number;
	rowCount: number;
	firstRowOnPage: number;
	lastRowOnPage: number;
	filters?: { [key: string]: any; } | undefined;
	sortOrder?: { [key: string]: any; } | undefined;
}

export class PagedResultOfEstablecimientoExtendedDto extends PagedResultBase implements IPagedResultOfEstablecimientoExtendedDto {
	results?: EstablecimientoExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfEstablecimientoExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(EstablecimientoExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfEstablecimientoExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfEstablecimientoExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfEstablecimientoExtendedDto extends IPagedResultBase {
	results?: EstablecimientoExtendedDto[] | undefined;
}

export class EstablecimientoExtendedDto implements IEstablecimientoExtendedDto {
	id!: number;
	nivelAtencion!: NivelAtencion;
	nivelAtencionString?: string | undefined;
	nombreEstablecimiento?: string | undefined;
	tipoCentro!: TipoCentro;
	tipoCentroString?: string | undefined;
	complejidadServicio!: ComplejidadServicio;
	complejidadServicioString?: string | undefined;
	administradoPor!: AdministradoPor;
	administradoPorString?: string | undefined;
	centroSuspendido!: boolean;
	regionSalud!: RegionSalud;
	regionSaludString?: string | undefined;
	provincia!: Provincia;
	provinciaString?: string | undefined;
	municipio!: Municipio;
	municipioString?: string | undefined;
	gerenciaAreaSalud!: GerenciaAreaSalud;
	gerenciaAreaSaludString?: string | undefined;
	totalUnap?: number | undefined;
	metaMensual!: number;
	totalRespuestasMensual!: number;

	constructor(data?: IEstablecimientoExtendedDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.nivelAtencion = _data["nivelAtencion"];
			this.nivelAtencionString = _data["nivelAtencionString"];
			this.nombreEstablecimiento = _data["nombreEstablecimiento"];
			this.tipoCentro = _data["tipoCentro"];
			this.tipoCentroString = _data["tipoCentroString"];
			this.complejidadServicio = _data["complejidadServicio"];
			this.complejidadServicioString = _data["complejidadServicioString"];
			this.administradoPor = _data["administradoPor"];
			this.administradoPorString = _data["administradoPorString"];
			this.centroSuspendido = _data["centroSuspendido"];
			this.regionSalud = _data["regionSalud"];
			this.regionSaludString = _data["regionSaludString"];
			this.provincia = _data["provincia"];
			this.provinciaString = _data["provinciaString"];
			this.municipio = _data["municipio"];
			this.municipioString = _data["municipioString"];
			this.gerenciaAreaSalud = _data["gerenciaAreaSalud"];
			this.gerenciaAreaSaludString = _data["gerenciaAreaSaludString"];
			this.totalUnap = _data["totalUnap"];
			this.metaMensual = _data["metaMensual"];
			this.totalRespuestasMensual = _data["totalRespuestasMensual"];
		}
	}

	static fromJS(data: any): EstablecimientoExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new EstablecimientoExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["nivelAtencion"] = this.nivelAtencion;
		data["nivelAtencionString"] = this.nivelAtencionString;
		data["nombreEstablecimiento"] = this.nombreEstablecimiento;
		data["tipoCentro"] = this.tipoCentro;
		data["tipoCentroString"] = this.tipoCentroString;
		data["complejidadServicio"] = this.complejidadServicio;
		data["complejidadServicioString"] = this.complejidadServicioString;
		data["administradoPor"] = this.administradoPor;
		data["administradoPorString"] = this.administradoPorString;
		data["centroSuspendido"] = this.centroSuspendido;
		data["regionSalud"] = this.regionSalud;
		data["regionSaludString"] = this.regionSaludString;
		data["provincia"] = this.provincia;
		data["provinciaString"] = this.provinciaString;
		data["municipio"] = this.municipio;
		data["municipioString"] = this.municipioString;
		data["gerenciaAreaSalud"] = this.gerenciaAreaSalud;
		data["gerenciaAreaSaludString"] = this.gerenciaAreaSaludString;
		data["totalUnap"] = this.totalUnap;
		data["metaMensual"] = this.metaMensual;
		data["totalRespuestasMensual"] = this.totalRespuestasMensual;
		return data;
	}
}

export interface IEstablecimientoExtendedDto {
	id: number;
	nivelAtencion: NivelAtencion;
	nivelAtencionString?: string | undefined;
	nombreEstablecimiento?: string | undefined;
	tipoCentro: TipoCentro;
	tipoCentroString?: string | undefined;
	complejidadServicio: ComplejidadServicio;
	complejidadServicioString?: string | undefined;
	administradoPor: AdministradoPor;
	administradoPorString?: string | undefined;
	centroSuspendido: boolean;
	regionSalud: RegionSalud;
	regionSaludString?: string | undefined;
	provincia: Provincia;
	provinciaString?: string | undefined;
	municipio: Municipio;
	municipioString?: string | undefined;
	gerenciaAreaSalud: GerenciaAreaSalud;
	gerenciaAreaSaludString?: string | undefined;
	totalUnap?: number | undefined;
	metaMensual: number;
	totalRespuestasMensual: number;
}

export enum NivelAtencion {
	PrimerNivel = 1,
	SegundoNivel = 2,
	TercelNivel = 3,
}

export enum TipoCentro {
	CentroPrimerNivel = 1,
	CentroZona = 2,
	CentroDiagnostico = 3,
	ConsultorioMedico = 4,
	ServicioAtencionIntegral = 5,
	Hospital = 6,
	HospitalDocente = 7,
	HospitalInfantil = 8,
	HospitalMaternoInfantil = 9,
}

export enum ComplejidadServicio {
	NoAplica = 1,
	HospitalGeneral = 2,
	CentroEspecializado = 3,
	CentroAltaEspecialidad = 4,
}

export enum AdministradoPor {
	Ffaa = 1,
	Idss = 2,
	Iglesia = 3,
	Minerd = 4,
	Ong = 5,
	Pn = 6,
	Privado = 7,
	Semma = 8,
	Sns = 9,
}

export enum RegionSalud {
	Region0 = 1,
	Region1 = 2,
	Region2 = 3,
	Region3 = 4,
	Region4 = 5,
	Region5 = 6,
	Region6 = 7,
	Region7 = 8,
	Region8 = 9,
}

export enum Provincia {
	Santiago = 11,
	PuertoPlata = 12,
	Espaillat = 13,
	LaVega = 14,
	MonseñorNouel = 15,
	SánchezRamírez = 16,
	Duarte = 17,
	HermanasMirabal = 18,
	MaríaTrinidadSánchez = 19,
	Samaná = 20,
	Valverde = 21,
	MonteCristi = 22,
	Dajabón = 23,
	SantiagoRodríguez = 24,
	SanCristóbal = 25,
	Azua = 26,
	Peravia = 27,
	SanJoséDeOcoa = 28,
	Barahona = 29,
	Baoruco = 30,
	Pedernales = 31,
	Independencia = 32,
	SanJuan = 33,
	ElíasPiña = 34,
	LaRomana = 35,
	LaAltagracia = 36,
	ElSeibo = 37,
	SanPedroDeMacorís = 38,
	HatoMayor = 39,
	MontePlata = 40,
	DistritoNacional = 41,
	SantoDomingo = 42,
}

export enum Municipio {
	Santiago = 43,
	Bisonó = 44,
	Jánico = 45,
	LiceyAlMedio = 46,
	SanJoséDeLasMatas = 47,
	Tamboril = 48,
	VillaGonzález = 49,
	Puñal = 50,
	SabanaIglesia = 51,
	Guananico = 52,
	Imbert = 53,
	PuertoPlata = 54,
	Altamira = 55,
	LosHidalgos = 56,
	Luperón = 57,
	Sosúa = 58,
	VillaIsabela = 59,
	VillaMontellano = 60,
	Moca = 61,
	CayetanoGermosén = 62,
	GasparHernández = 63,
	JamaoAlNorte = 64,
	Constanza = 65,
	LaVega = 66,
	Jarabacoa = 67,
	JimaAbajo = 68,
	Bonao = 69,
	Maimón = 70,
	PiedraBlanca = 71,
	Cotuí = 72,
	Cevicos = 73,
	Fantino = 74,
	LaMata = 75,
	SanFranciscoDeMacorís = 76,
	Arenoso = 77,
	Castillo = 78,
	LasGuáranas = 79,
	EugenioMaríaDeHostos = 80,
	Pimentel = 81,
	VillaRiva = 82,
	Salcedo = 83,
	Tenares = 84,
	VillaTapia = 85,
	Nagua = 86,
	Cabrera = 87,
	ElFactor = 88,
	RíoSanJuan = 89,
	Samaná = 90,
	Sánchez = 91,
	LasTerrenas = 92,
	Mao = 93,
	Esperanza = 94,
	LagunaSalada = 95,
	Castañuelas = 96,
	Guayubín = 97,
	MonteCristi = 98,
	LasMatasDeSantaCruz = 99,
	PepilloSalcedo = 100,
	VillaVásquez = 101,
	Dajabón = 102,
	LomaDeCabrera = 103,
	Partido = 104,
	Restauración = 105,
	ElPino = 106,
	SanIgnacioDeSabaneta = 107,
	VillaLosAlmácigos = 108,
	Monción = 109,
	SanCristóbal = 110,
	SabanaGrandeDePalenque = 111,
	BajosDeHaina = 112,
	CambitaGarabitos = 113,
	VillaAltagracia = 114,
	Yaguate = 115,
	SanGregorioDeNigua = 116,
	LosCacaos = 117,
	LasCharcas = 118,
	LasYayasDeViajama = 119,
	Peralta = 120,
	SabanaYegua = 121,
	PuebloViejo = 122,
	Azua = 123,
	PadreLasCasas = 124,
	TábaraArriba = 125,
	Guayabal = 126,
	Estebanía = 127,
	Baní = 128,
	Nizao = 129,
	SanJoséDeOcoa = 130,
	SabanaLarga = 131,
	RanchoArriba = 132,
	Cabral = 133,
	Enriquillo = 134,
	ElPeñón = 135,
	LaCiénaga = 136,
	Fundación = 137,
	Paraíso = 138,
	VicenteNoble = 139,
	LasSalinas = 140,
	Polo = 141,
	Jaquimeyes = 142,
	Barahona = 143,
	Neiba = 144,
	VillaJaragua = 145,
	LosRíos = 146,
	Galván = 147,
	Tamayo = 148,
	Pedernales = 149,
	Oviedo = 150,
	Jimaní = 151,
	Duvergé = 152,
	LaDescubierta = 153,
	PostrerRío = 154,
	Cristóbal = 155,
	Mella = 156,
	Bohechío = 157,
	ElCercado = 158,
	SanJuan = 159,
	JuanDeHerrera = 160,
	LasMatasDeFarfán = 161,
	Vallejuelo = 162,
	Comendador = 163,
	ElLlano = 164,
	HondoValle = 165,
	JuanSantiago = 166,
	Bánica = 167,
	PedroSantana = 168,
	LaRomana = 169,
	Guaymate = 170,
	VillaHermosa = 171,
	Higüey = 172,
	SanRafaelDelYuma = 173,
	ElSeibo = 174,
	Miches = 175,
	SanPedroDeMacorís = 176,
	LosLlanos = 177,
	RamónSantana = 178,
	Consuelo = 179,
	Quisqueya = 180,
	Guayacanes = 181,
	HatoMayor = 182,
	SabanaDeLaMar = 183,
	ElValle = 184,
	MontePlata = 185,
	Bayaguana = 186,
	SabanaGrandeDeBoyá = 187,
	Yamasá = 188,
	Peralvillo = 189,
	SantoDomingoDeGuzmán = 190,
	SantoDomingoEste = 191,
	SantoDomingoOeste = 192,
	SantoDomingoNorte = 193,
	BocaChica = 194,
	SanAntonioDeGuerra = 195,
	LosAlcarrizos = 196,
	PedroBrand = 197,
}

export enum GerenciaAreaSalud {
	DistritoNacionalEste = 1,
	DistritoNacionalOeste = 2,
	MontePlata = 3,
	SantoDomingoEsteCentro = 4,
	SantoDomingoEsteMunicipal = 5,
	SantoDomingoEsteOriental = 6,
	SantoDomingoNorte = 8,
	SantoDomingoOeste = 9,
	Peravia = 11,
	SanCristóbalEste = 12,
	SanCristóbalNorte = 13,
	SanCristóbalSur = 14,
	SanJoséDeOcoa = 15,
	Espaillat = 16,
	PuertoPlata = 17,
	SantiagoLaSierra = 18,
	SantiagoNorte = 19,
	SantiagoOeste = 20,
	SantiagoSur = 21,
	Duarte = 22,
	HermanasMirabal = 23,
	MaríaTrinidadSánchez = 24,
	Samaná = 25,
	Bahoruco = 26,
	Barahona = 27,
	Independencia = 28,
	Pedernales = 29,
	ElSeibo = 30,
	HatoMayor = 31,
	LaAltagracia = 32,
	LaRomana = 33,
	SanPedroDeMacorís = 34,
	Azua = 35,
	ElíasPiña = 36,
	SanJuan = 37,
	Dajabón = 38,
	MonteCristi = 39,
	SantiagoRodríguez = 40,
	Valverde = 41,
	LaVega = 42,
	MonseñorNouel = 43,
	SánchezRamírez = 44,
}

export class ProblemDetails implements IProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	constructor(data?: IProblemDetails) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.type = _data["type"];
			this.title = _data["title"];
			this.status = _data["status"];
			this.detail = _data["detail"];
			this.instance = _data["instance"];
		}
	}

	static fromJS(data: any): ProblemDetails {
		data = typeof data === 'object' ? data : {};
		let result = new ProblemDetails();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["type"] = this.type;
		data["title"] = this.title;
		data["status"] = this.status;
		data["detail"] = this.detail;
		data["instance"] = this.instance;
		return data;
	}
}

export interface IProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;
}

export class GenericItemDto implements IGenericItemDto {
	id!: number;
	name?: string | undefined;

	constructor(data?: IGenericItemDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.name = _data["name"];
		}
	}

	static fromJS(data: any): GenericItemDto {
		data = typeof data === 'object' ? data : {};
		let result = new GenericItemDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["name"] = this.name;
		return data;
	}
}

export interface IGenericItemDto {
	id: number;
	name?: string | undefined;
}

export class UsuarioDto implements IUsuarioDto {
	id!: string;
	nombres?: string | undefined;
	apellidos?: string | undefined;
	cedula?: string | undefined;
	lastLogin?: Date | undefined;
	rolId?: string | undefined;
	regionSalud?: RegionSalud | undefined;
	gerenciaAreaSalud?: GerenciaAreaSalud | undefined;
	establecimientoId?: number | undefined;
	nombreCompleto?: string | undefined;
	isEnabled!: boolean;

	constructor(data?: IUsuarioDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.nombres = _data["nombres"];
			this.apellidos = _data["apellidos"];
			this.cedula = _data["cedula"];
			this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
			this.rolId = _data["rolId"];
			this.regionSalud = _data["regionSalud"];
			this.gerenciaAreaSalud = _data["gerenciaAreaSalud"];
			this.establecimientoId = _data["establecimientoId"];
			this.nombreCompleto = _data["nombreCompleto"];
			this.isEnabled = _data["isEnabled"];
		}
	}

	static fromJS(data: any): UsuarioDto {
		data = typeof data === 'object' ? data : {};
		let result = new UsuarioDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["nombres"] = this.nombres;
		data["apellidos"] = this.apellidos;
		data["cedula"] = this.cedula;
		data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
		data["rolId"] = this.rolId;
		data["regionSalud"] = this.regionSalud;
		data["gerenciaAreaSalud"] = this.gerenciaAreaSalud;
		data["establecimientoId"] = this.establecimientoId;
		data["nombreCompleto"] = this.nombreCompleto;
		data["isEnabled"] = this.isEnabled;
		return data;
	}
}

export interface IUsuarioDto {
	id: string;
	nombres?: string | undefined;
	apellidos?: string | undefined;
	cedula?: string | undefined;
	lastLogin?: Date | undefined;
	rolId?: string | undefined;
	regionSalud?: RegionSalud | undefined;
	gerenciaAreaSalud?: GerenciaAreaSalud | undefined;
	establecimientoId?: number | undefined;
	nombreCompleto?: string | undefined;
	isEnabled: boolean;
}

export class UsuarioExtendedDto extends UsuarioDto implements IUsuarioExtendedDto {
	rol?: RolDto | undefined;
	isAdmin!: boolean;

	constructor(data?: IUsuarioExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.rol = _data["rol"] ? RolDto.fromJS(_data["rol"]) : <any>undefined;
			this.isAdmin = _data["isAdmin"];
		}
	}

	static fromJS(data: any): UsuarioExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new UsuarioExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["rol"] = this.rol ? this.rol.toJSON() : <any>undefined;
		data["isAdmin"] = this.isAdmin;
		super.toJSON(data);
		return data;
	}
}

export interface IUsuarioExtendedDto extends IUsuarioDto {
	rol?: RolDto | undefined;
	isAdmin: boolean;
}

export class GenericItemDtoOfGuid implements IGenericItemDtoOfGuid {
	id!: string;
	name?: string | undefined;

	constructor(data?: IGenericItemDtoOfGuid) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.name = _data["name"];
		}
	}

	static fromJS(data: any): GenericItemDtoOfGuid {
		data = typeof data === 'object' ? data : {};
		let result = new GenericItemDtoOfGuid();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["name"] = this.name;
		return data;
	}
}

export interface IGenericItemDtoOfGuid {
	id: string;
	name?: string | undefined;
}

export class RolDto extends GenericItemDtoOfGuid implements IRolDto {
	hierarchyLevel!: HierarchyLevel;

	constructor(data?: IRolDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.hierarchyLevel = _data["hierarchyLevel"];
		}
	}

	static fromJS(data: any): RolDto {
		data = typeof data === 'object' ? data : {};
		let result = new RolDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["hierarchyLevel"] = this.hierarchyLevel;
		super.toJSON(data);
		return data;
	}
}

export interface IRolDto extends IGenericItemDtoOfGuid {
	hierarchyLevel: HierarchyLevel;
}

export enum HierarchyLevel {
	Encuestador = 1,
	AuxiliarDeAtenciónAlUsuario = 2,
	EncargadoDeAtenciónAlUsuario = 3,
	DirectorEstablecimiento = 4,
	DirectorMunicipal = 5,
	DirectorRegional = 6,
	EncargadoNivelCentral = 7,
	DirectorGeneral = 8,
	Administrador = 9,
}

export class EstablecimientoDto implements IEstablecimientoDto {
	id!: number;
	nivelAtencion!: NivelAtencion;
	nombreEstablecimiento?: string | undefined;
	tipoCentro!: TipoCentro;
	complejidadServicio!: ComplejidadServicio;
	administradoPor!: AdministradoPor;
	centroSuspendido!: boolean;
	regionSalud!: RegionSalud;
	provincia!: Provincia;
	municipio!: Municipio;
	gerenciaAreaSalud!: GerenciaAreaSalud;
	totalUnap?: number | undefined;
	metaMensual!: number;

	constructor(data?: IEstablecimientoDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.nivelAtencion = _data["nivelAtencion"];
			this.nombreEstablecimiento = _data["nombreEstablecimiento"];
			this.tipoCentro = _data["tipoCentro"];
			this.complejidadServicio = _data["complejidadServicio"];
			this.administradoPor = _data["administradoPor"];
			this.centroSuspendido = _data["centroSuspendido"];
			this.regionSalud = _data["regionSalud"];
			this.provincia = _data["provincia"];
			this.municipio = _data["municipio"];
			this.gerenciaAreaSalud = _data["gerenciaAreaSalud"];
			this.totalUnap = _data["totalUnap"];
			this.metaMensual = _data["metaMensual"];
		}
	}

	static fromJS(data: any): EstablecimientoDto {
		data = typeof data === 'object' ? data : {};
		let result = new EstablecimientoDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["nivelAtencion"] = this.nivelAtencion;
		data["nombreEstablecimiento"] = this.nombreEstablecimiento;
		data["tipoCentro"] = this.tipoCentro;
		data["complejidadServicio"] = this.complejidadServicio;
		data["administradoPor"] = this.administradoPor;
		data["centroSuspendido"] = this.centroSuspendido;
		data["regionSalud"] = this.regionSalud;
		data["provincia"] = this.provincia;
		data["municipio"] = this.municipio;
		data["gerenciaAreaSalud"] = this.gerenciaAreaSalud;
		data["totalUnap"] = this.totalUnap;
		data["metaMensual"] = this.metaMensual;
		return data;
	}
}

export interface IEstablecimientoDto {
	id: number;
	nivelAtencion: NivelAtencion;
	nombreEstablecimiento?: string | undefined;
	tipoCentro: TipoCentro;
	complejidadServicio: ComplejidadServicio;
	administradoPor: AdministradoPor;
	centroSuspendido: boolean;
	regionSalud: RegionSalud;
	provincia: Provincia;
	municipio: Municipio;
	gerenciaAreaSalud: GerenciaAreaSalud;
	totalUnap?: number | undefined;
	metaMensual: number;
}

export class EstablecimientoOptionDto implements IEstablecimientoOptionDto {
	administradoPor?: EnumDtoOfAdministradoPor[] | undefined;
	complejidadServicio?: EnumDtoOfComplejidadServicio[] | undefined;
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	provincia?: ProvinciaDto[] | undefined;
	regionSalud?: RegionSaludDto[] | undefined;
	tipoCentro?: EnumDtoOfTipoCentro[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;

	constructor(data?: IEstablecimientoOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["administradoPor"])) {
				this.administradoPor = [] as any;
				for (let item of _data["administradoPor"])
					this.administradoPor!.push(EnumDtoOfAdministradoPor.fromJS(item));
			}
			if (Array.isArray(_data["complejidadServicio"])) {
				this.complejidadServicio = [] as any;
				for (let item of _data["complejidadServicio"])
					this.complejidadServicio!.push(EnumDtoOfComplejidadServicio.fromJS(item));
			}
			if (Array.isArray(_data["nivelAtencion"])) {
				this.nivelAtencion = [] as any;
				for (let item of _data["nivelAtencion"])
					this.nivelAtencion!.push(EnumDtoOfNivelAtencion.fromJS(item));
			}
			if (Array.isArray(_data["provincia"])) {
				this.provincia = [] as any;
				for (let item of _data["provincia"])
					this.provincia!.push(ProvinciaDto.fromJS(item));
			}
			if (Array.isArray(_data["regionSalud"])) {
				this.regionSalud = [] as any;
				for (let item of _data["regionSalud"])
					this.regionSalud!.push(RegionSaludDto.fromJS(item));
			}
			if (Array.isArray(_data["tipoCentro"])) {
				this.tipoCentro = [] as any;
				for (let item of _data["tipoCentro"])
					this.tipoCentro!.push(EnumDtoOfTipoCentro.fromJS(item));
			}
			if (Array.isArray(_data["tipoSolicitud"])) {
				this.tipoSolicitud = [] as any;
				for (let item of _data["tipoSolicitud"])
					this.tipoSolicitud!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["tipoServicio"])) {
				this.tipoServicio = [] as any;
				for (let item of _data["tipoServicio"])
					this.tipoServicio!.push(GenericItemDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): EstablecimientoOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new EstablecimientoOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.administradoPor)) {
			data["administradoPor"] = [];
			for (let item of this.administradoPor)
				data["administradoPor"].push(item.toJSON());
		}
		if (Array.isArray(this.complejidadServicio)) {
			data["complejidadServicio"] = [];
			for (let item of this.complejidadServicio)
				data["complejidadServicio"].push(item.toJSON());
		}
		if (Array.isArray(this.nivelAtencion)) {
			data["nivelAtencion"] = [];
			for (let item of this.nivelAtencion)
				data["nivelAtencion"].push(item.toJSON());
		}
		if (Array.isArray(this.provincia)) {
			data["provincia"] = [];
			for (let item of this.provincia)
				data["provincia"].push(item.toJSON());
		}
		if (Array.isArray(this.regionSalud)) {
			data["regionSalud"] = [];
			for (let item of this.regionSalud)
				data["regionSalud"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoCentro)) {
			data["tipoCentro"] = [];
			for (let item of this.tipoCentro)
				data["tipoCentro"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoSolicitud)) {
			data["tipoSolicitud"] = [];
			for (let item of this.tipoSolicitud)
				data["tipoSolicitud"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoServicio)) {
			data["tipoServicio"] = [];
			for (let item of this.tipoServicio)
				data["tipoServicio"].push(item.toJSON());
		}
		return data;
	}
}

export interface IEstablecimientoOptionDto {
	administradoPor?: EnumDtoOfAdministradoPor[] | undefined;
	complejidadServicio?: EnumDtoOfComplejidadServicio[] | undefined;
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	provincia?: ProvinciaDto[] | undefined;
	regionSalud?: RegionSaludDto[] | undefined;
	tipoCentro?: EnumDtoOfTipoCentro[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;
}

export class EnumDtoOfAdministradoPor implements IEnumDtoOfAdministradoPor {
	value!: AdministradoPor;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfAdministradoPor) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfAdministradoPor {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfAdministradoPor();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfAdministradoPor {
	value: AdministradoPor;
	description?: string | undefined;
}

export class EnumDtoOfComplejidadServicio implements IEnumDtoOfComplejidadServicio {
	value!: ComplejidadServicio;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfComplejidadServicio) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfComplejidadServicio {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfComplejidadServicio();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfComplejidadServicio {
	value: ComplejidadServicio;
	description?: string | undefined;
}

export class EnumDtoOfNivelAtencion implements IEnumDtoOfNivelAtencion {
	value!: NivelAtencion;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfNivelAtencion) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfNivelAtencion {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfNivelAtencion();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfNivelAtencion {
	value: NivelAtencion;
	description?: string | undefined;
}

export class EnumDtoOfProvincia implements IEnumDtoOfProvincia {
	value!: Provincia;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfProvincia) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfProvincia {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfProvincia();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfProvincia {
	value: Provincia;
	description?: string | undefined;
}

export class ProvinciaDto extends EnumDtoOfProvincia implements IProvinciaDto {
	municipio?: EnumDtoOfMunicipio[] | undefined;

	constructor(data?: IProvinciaDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["municipio"])) {
				this.municipio = [] as any;
				for (let item of _data["municipio"])
					this.municipio!.push(EnumDtoOfMunicipio.fromJS(item));
			}
		}
	}

	static fromJS(data: any): ProvinciaDto {
		data = typeof data === 'object' ? data : {};
		let result = new ProvinciaDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.municipio)) {
			data["municipio"] = [];
			for (let item of this.municipio)
				data["municipio"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IProvinciaDto extends IEnumDtoOfProvincia {
	municipio?: EnumDtoOfMunicipio[] | undefined;
}

export class EnumDtoOfMunicipio implements IEnumDtoOfMunicipio {
	value!: Municipio;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfMunicipio) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfMunicipio {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfMunicipio();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfMunicipio {
	value: Municipio;
	description?: string | undefined;
}

export class EnumDtoOfRegionSalud implements IEnumDtoOfRegionSalud {
	value!: RegionSalud;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfRegionSalud) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfRegionSalud {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfRegionSalud();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfRegionSalud {
	value: RegionSalud;
	description?: string | undefined;
}

export class RegionSaludDto extends EnumDtoOfRegionSalud implements IRegionSaludDto {
	gerenciaAreaSalud?: EnumDtoOfGerenciaAreaSalud[] | undefined;

	constructor(data?: IRegionSaludDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["gerenciaAreaSalud"])) {
				this.gerenciaAreaSalud = [] as any;
				for (let item of _data["gerenciaAreaSalud"])
					this.gerenciaAreaSalud!.push(EnumDtoOfGerenciaAreaSalud.fromJS(item));
			}
		}
	}

	static fromJS(data: any): RegionSaludDto {
		data = typeof data === 'object' ? data : {};
		let result = new RegionSaludDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.gerenciaAreaSalud)) {
			data["gerenciaAreaSalud"] = [];
			for (let item of this.gerenciaAreaSalud)
				data["gerenciaAreaSalud"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IRegionSaludDto extends IEnumDtoOfRegionSalud {
	gerenciaAreaSalud?: EnumDtoOfGerenciaAreaSalud[] | undefined;
}

export class EnumDtoOfGerenciaAreaSalud implements IEnumDtoOfGerenciaAreaSalud {
	value!: GerenciaAreaSalud;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfGerenciaAreaSalud) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfGerenciaAreaSalud {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfGerenciaAreaSalud();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfGerenciaAreaSalud {
	value: GerenciaAreaSalud;
	description?: string | undefined;
}

export class EnumDtoOfTipoCentro implements IEnumDtoOfTipoCentro {
	value!: TipoCentro;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfTipoCentro) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfTipoCentro {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfTipoCentro();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfTipoCentro {
	value: TipoCentro;
	description?: string | undefined;
}

export class PagedResultOfFormularioExtendedDto extends PagedResultBase implements IPagedResultOfFormularioExtendedDto {
	results?: FormularioExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfFormularioExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(FormularioExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfFormularioExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfFormularioExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfFormularioExtendedDto extends IPagedResultBase {
	results?: FormularioExtendedDto[] | undefined;
}

export class FormularioExtendedNoCollectionsDto implements IFormularioExtendedNoCollectionsDto {
	id!: number;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	piePagina?: string | undefined;
	tipoFormulario!: TipoFormulario;
	tipoFormularioString?: string | undefined;
	requiereDatosEncuestado!: boolean;
	requiereSeguimiento!: boolean;
	esVisible!: boolean;
	totalRespuestas!: number;

	constructor(data?: IFormularioExtendedNoCollectionsDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.titulo = _data["titulo"];
			this.subtitulo = _data["subtitulo"];
			this.piePagina = _data["piePagina"];
			this.tipoFormulario = _data["tipoFormulario"];
			this.tipoFormularioString = _data["tipoFormularioString"];
			this.requiereDatosEncuestado = _data["requiereDatosEncuestado"];
			this.requiereSeguimiento = _data["requiereSeguimiento"];
			this.esVisible = _data["esVisible"];
			this.totalRespuestas = _data["totalRespuestas"];
		}
	}

	static fromJS(data: any): FormularioExtendedNoCollectionsDto {
		data = typeof data === 'object' ? data : {};
		let result = new FormularioExtendedNoCollectionsDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["titulo"] = this.titulo;
		data["subtitulo"] = this.subtitulo;
		data["piePagina"] = this.piePagina;
		data["tipoFormulario"] = this.tipoFormulario;
		data["tipoFormularioString"] = this.tipoFormularioString;
		data["requiereDatosEncuestado"] = this.requiereDatosEncuestado;
		data["requiereSeguimiento"] = this.requiereSeguimiento;
		data["esVisible"] = this.esVisible;
		data["totalRespuestas"] = this.totalRespuestas;
		return data;
	}
}

export interface IFormularioExtendedNoCollectionsDto {
	id: number;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	piePagina?: string | undefined;
	tipoFormulario: TipoFormulario;
	tipoFormularioString?: string | undefined;
	requiereDatosEncuestado: boolean;
	requiereSeguimiento: boolean;
	esVisible: boolean;
	totalRespuestas: number;
}

export class FormularioExtendedDto extends FormularioExtendedNoCollectionsDto implements IFormularioExtendedDto {
	preguntas?: PreguntaExtendedDto[] | undefined;

	constructor(data?: IFormularioExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["preguntas"])) {
				this.preguntas = [] as any;
				for (let item of _data["preguntas"])
					this.preguntas!.push(PreguntaExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): FormularioExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new FormularioExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.preguntas)) {
			data["preguntas"] = [];
			for (let item of this.preguntas)
				data["preguntas"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IFormularioExtendedDto extends IFormularioExtendedNoCollectionsDto {
	preguntas?: PreguntaExtendedDto[] | undefined;
}

export class PreguntaExtendedNoCollectionsDto implements IPreguntaExtendedNoCollectionsDto {
	id!: number;
	tipoPregunta!: TipoPregunta;
	tipoPreguntaString?: string | undefined;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	descripcionMinimo?: string | undefined;
	descripcionMaximo?: string | undefined;

	constructor(data?: IPreguntaExtendedNoCollectionsDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.tipoPregunta = _data["tipoPregunta"];
			this.tipoPreguntaString = _data["tipoPreguntaString"];
			this.titulo = _data["titulo"];
			this.subtitulo = _data["subtitulo"];
			this.descripcionMinimo = _data["descripcionMinimo"];
			this.descripcionMaximo = _data["descripcionMaximo"];
		}
	}

	static fromJS(data: any): PreguntaExtendedNoCollectionsDto {
		data = typeof data === 'object' ? data : {};
		let result = new PreguntaExtendedNoCollectionsDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["tipoPregunta"] = this.tipoPregunta;
		data["tipoPreguntaString"] = this.tipoPreguntaString;
		data["titulo"] = this.titulo;
		data["subtitulo"] = this.subtitulo;
		data["descripcionMinimo"] = this.descripcionMinimo;
		data["descripcionMaximo"] = this.descripcionMaximo;
		return data;
	}
}

export interface IPreguntaExtendedNoCollectionsDto {
	id: number;
	tipoPregunta: TipoPregunta;
	tipoPreguntaString?: string | undefined;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	descripcionMinimo?: string | undefined;
	descripcionMaximo?: string | undefined;
}

export class PreguntaExtendedDto extends PreguntaExtendedNoCollectionsDto implements IPreguntaExtendedDto {
	grupoOpcionId?: number | undefined;
	opciones?: OpcionExtendedWithDescriptionDto[] | undefined;

	constructor(data?: IPreguntaExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.grupoOpcionId = _data["grupoOpcionId"];
			if (Array.isArray(_data["opciones"])) {
				this.opciones = [] as any;
				for (let item of _data["opciones"])
					this.opciones!.push(OpcionExtendedWithDescriptionDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PreguntaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PreguntaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["grupoOpcionId"] = this.grupoOpcionId;
		if (Array.isArray(this.opciones)) {
			data["opciones"] = [];
			for (let item of this.opciones)
				data["opciones"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPreguntaExtendedDto extends IPreguntaExtendedNoCollectionsDto {
	grupoOpcionId?: number | undefined;
	opciones?: OpcionExtendedWithDescriptionDto[] | undefined;
}

export class OpcionDto implements IOpcionDto {
	id!: number;
	valor?: string | undefined;

	constructor(data?: IOpcionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.valor = _data["valor"];
		}
	}

	static fromJS(data: any): OpcionDto {
		data = typeof data === 'object' ? data : {};
		let result = new OpcionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["valor"] = this.valor;
		return data;
	}
}

export interface IOpcionDto {
	id: number;
	valor?: string | undefined;
}

export class OpcionExtendedDto extends OpcionDto implements IOpcionExtendedDto {
	peso!: number;
	orden!: number;

	constructor(data?: IOpcionExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.peso = _data["peso"];
			this.orden = _data["orden"];
		}
	}

	static fromJS(data: any): OpcionExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new OpcionExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["peso"] = this.peso;
		data["orden"] = this.orden;
		super.toJSON(data);
		return data;
	}
}

export interface IOpcionExtendedDto extends IOpcionDto {
	peso: number;
	orden: number;
}

export class OpcionExtendedWithDescriptionDto extends OpcionExtendedDto implements IOpcionExtendedWithDescriptionDto {
	descripcion?: string | undefined;

	constructor(data?: IOpcionExtendedWithDescriptionDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.descripcion = _data["descripcion"];
		}
	}

	static fromJS(data: any): OpcionExtendedWithDescriptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new OpcionExtendedWithDescriptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["descripcion"] = this.descripcion;
		super.toJSON(data);
		return data;
	}
}

export interface IOpcionExtendedWithDescriptionDto extends IOpcionExtendedDto {
	descripcion?: string | undefined;
}

export enum TipoPregunta {
	PreguntaUnaRespuesta = 1,
	PreguntaMultipleRespuesta = 2,
	PreguntaRespuestaCorta = 3,
	PreguntaAbierta = 4,
	PreguntaEscalaValoracion = 5,
	PreguntaUnaRespuestaOAbierta = 6,
	PreguntaMultipleRespuestaOAbierta = 7,
	PreguntaEscalaValoracionNumerica = 8,
	NetPromoterScore = 9,
}

export enum TipoFormulario {
	EncuestaSatisfaccion = 1,
	FormularioQuejasSugerencias = 2,
}

export class FormularioDto implements IFormularioDto {
	id!: number;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	piePagina?: string | undefined;
	tipoFormulario!: TipoFormulario;
	requiereDatosEncuestado!: boolean;
	requiereSeguimiento!: boolean;
	esVisible!: boolean;

	constructor(data?: IFormularioDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.titulo = _data["titulo"];
			this.subtitulo = _data["subtitulo"];
			this.piePagina = _data["piePagina"];
			this.tipoFormulario = _data["tipoFormulario"];
			this.requiereDatosEncuestado = _data["requiereDatosEncuestado"];
			this.requiereSeguimiento = _data["requiereSeguimiento"];
			this.esVisible = _data["esVisible"];
		}
	}

	static fromJS(data: any): FormularioDto {
		data = typeof data === 'object' ? data : {};
		let result = new FormularioDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["titulo"] = this.titulo;
		data["subtitulo"] = this.subtitulo;
		data["piePagina"] = this.piePagina;
		data["tipoFormulario"] = this.tipoFormulario;
		data["requiereDatosEncuestado"] = this.requiereDatosEncuestado;
		data["requiereSeguimiento"] = this.requiereSeguimiento;
		data["esVisible"] = this.esVisible;
		return data;
	}
}

export interface IFormularioDto {
	id: number;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	piePagina?: string | undefined;
	tipoFormulario: TipoFormulario;
	requiereDatosEncuestado: boolean;
	requiereSeguimiento: boolean;
	esVisible: boolean;
}

export class FormularioOptionDto implements IFormularioOptionDto {
	tipoFormulario?: EnumDtoOfTipoFormulario[] | undefined;

	constructor(data?: IFormularioOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["tipoFormulario"])) {
				this.tipoFormulario = [] as any;
				for (let item of _data["tipoFormulario"])
					this.tipoFormulario!.push(EnumDtoOfTipoFormulario.fromJS(item));
			}
		}
	}

	static fromJS(data: any): FormularioOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new FormularioOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.tipoFormulario)) {
			data["tipoFormulario"] = [];
			for (let item of this.tipoFormulario)
				data["tipoFormulario"].push(item.toJSON());
		}
		return data;
	}
}

export interface IFormularioOptionDto {
	tipoFormulario?: EnumDtoOfTipoFormulario[] | undefined;
}

export class EnumDtoOfTipoFormulario implements IEnumDtoOfTipoFormulario {
	value!: TipoFormulario;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfTipoFormulario) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfTipoFormulario {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfTipoFormulario();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfTipoFormulario {
	value: TipoFormulario;
	description?: string | undefined;
}

export class PagedResultOfGrupoOpcionExtendedDto extends PagedResultBase implements IPagedResultOfGrupoOpcionExtendedDto {
	results?: GrupoOpcionExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfGrupoOpcionExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(GrupoOpcionExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfGrupoOpcionExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfGrupoOpcionExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfGrupoOpcionExtendedDto extends IPagedResultBase {
	results?: GrupoOpcionExtendedDto[] | undefined;
}

export class GrupoOpcionDto implements IGrupoOpcionDto {
	id!: number;
	nombre?: string | undefined;

	constructor(data?: IGrupoOpcionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.nombre = _data["nombre"];
		}
	}

	static fromJS(data: any): GrupoOpcionDto {
		data = typeof data === 'object' ? data : {};
		let result = new GrupoOpcionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["nombre"] = this.nombre;
		return data;
	}
}

export interface IGrupoOpcionDto {
	id: number;
	nombre?: string | undefined;
}

export class GrupoOpcionExtendedDto extends GrupoOpcionDto implements IGrupoOpcionExtendedDto {
	opciones?: OpcionExtendedDto[] | undefined;

	constructor(data?: IGrupoOpcionExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["opciones"])) {
				this.opciones = [] as any;
				for (let item of _data["opciones"])
					this.opciones!.push(OpcionExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): GrupoOpcionExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new GrupoOpcionExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.opciones)) {
			data["opciones"] = [];
			for (let item of this.opciones)
				data["opciones"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IGrupoOpcionExtendedDto extends IGrupoOpcionDto {
	opciones?: OpcionExtendedDto[] | undefined;
}

export class OpcionOrdenDto implements IOpcionOrdenDto {
	opcionId!: number;
	orden!: number;

	constructor(data?: IOpcionOrdenDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.opcionId = _data["opcionId"];
			this.orden = _data["orden"];
		}
	}

	static fromJS(data: any): OpcionOrdenDto {
		data = typeof data === 'object' ? data : {};
		let result = new OpcionOrdenDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["opcionId"] = this.opcionId;
		data["orden"] = this.orden;
		return data;
	}
}

export interface IOpcionOrdenDto {
	opcionId: number;
	orden: number;
}

export class PagedResultOfOpcionDto extends PagedResultBase implements IPagedResultOfOpcionDto {
	results?: OpcionDto[] | undefined;

	constructor(data?: IPagedResultOfOpcionDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(OpcionDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfOpcionDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfOpcionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfOpcionDto extends IPagedResultBase {
	results?: OpcionDto[] | undefined;
}

export class PagedResultOfPreguntaExtendedDto extends PagedResultBase implements IPagedResultOfPreguntaExtendedDto {
	results?: PreguntaExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfPreguntaExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(PreguntaExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfPreguntaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfPreguntaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfPreguntaExtendedDto extends IPagedResultBase {
	results?: PreguntaExtendedDto[] | undefined;
}

export class PreguntaDto implements IPreguntaDto {
	id!: number;
	tipoPregunta!: TipoPregunta;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	descripcionMinimo?: string | undefined;
	descripcionMaximo?: string | undefined;

	constructor(data?: IPreguntaDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.tipoPregunta = _data["tipoPregunta"];
			this.titulo = _data["titulo"];
			this.subtitulo = _data["subtitulo"];
			this.descripcionMinimo = _data["descripcionMinimo"];
			this.descripcionMaximo = _data["descripcionMaximo"];
		}
	}

	static fromJS(data: any): PreguntaDto {
		data = typeof data === 'object' ? data : {};
		let result = new PreguntaDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["tipoPregunta"] = this.tipoPregunta;
		data["titulo"] = this.titulo;
		data["subtitulo"] = this.subtitulo;
		data["descripcionMinimo"] = this.descripcionMinimo;
		data["descripcionMaximo"] = this.descripcionMaximo;
		return data;
	}
}

export interface IPreguntaDto {
	id: number;
	tipoPregunta: TipoPregunta;
	titulo?: string | undefined;
	subtitulo?: string | undefined;
	descripcionMinimo?: string | undefined;
	descripcionMaximo?: string | undefined;
}

export class PreguntaOptionDto implements IPreguntaOptionDto {
	tipoPregunta?: EnumDtoOfTipoPregunta[] | undefined;

	constructor(data?: IPreguntaOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["tipoPregunta"])) {
				this.tipoPregunta = [] as any;
				for (let item of _data["tipoPregunta"])
					this.tipoPregunta!.push(EnumDtoOfTipoPregunta.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PreguntaOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new PreguntaOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.tipoPregunta)) {
			data["tipoPregunta"] = [];
			for (let item of this.tipoPregunta)
				data["tipoPregunta"].push(item.toJSON());
		}
		return data;
	}
}

export interface IPreguntaOptionDto {
	tipoPregunta?: EnumDtoOfTipoPregunta[] | undefined;
}

export class EnumDtoOfTipoPregunta implements IEnumDtoOfTipoPregunta {
	value!: TipoPregunta;
	description?: string | undefined;

	constructor(data?: IEnumDtoOfTipoPregunta) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.value = _data["value"];
			this.description = _data["description"];
		}
	}

	static fromJS(data: any): EnumDtoOfTipoPregunta {
		data = typeof data === 'object' ? data : {};
		let result = new EnumDtoOfTipoPregunta();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["value"] = this.value;
		data["description"] = this.description;
		return data;
	}
}

export interface IEnumDtoOfTipoPregunta {
	value: TipoPregunta;
	description?: string | undefined;
}

export class BaseReporteDto implements IBaseReporteDto {
	filters?: { [key: string]: any; } | undefined;

	constructor(data?: IBaseReporteDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (_data["filters"]) {
				this.filters = {} as any;
				for (let key in _data["filters"]) {
					if (_data["filters"].hasOwnProperty(key))
						this.filters![key] = _data["filters"][key];
				}
			}
		}
	}

	static fromJS(data: any): BaseReporteDto {
		data = typeof data === 'object' ? data : {};
		let result = new BaseReporteDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (this.filters) {
			data["filters"] = {};
			for (let key in this.filters) {
				if (this.filters.hasOwnProperty(key))
					data["filters"][key] = this.filters[key];
			}
		}
		return data;
	}
}

export interface IBaseReporteDto {
	filters?: { [key: string]: any; } | undefined;
}

export class ReporteSatisfaccionDto extends BaseReporteDto implements IReporteSatisfaccionDto {
	generalSatisfaction?: SeriesDtoOfDecimal[] | undefined;
	customerSatisfaction?: SeriesDtoOfDecimal[] | undefined;

	constructor(data?: IReporteSatisfaccionDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["generalSatisfaction"])) {
				this.generalSatisfaction = [] as any;
				for (let item of _data["generalSatisfaction"])
					this.generalSatisfaction!.push(SeriesDtoOfDecimal.fromJS(item));
			}
			if (Array.isArray(_data["customerSatisfaction"])) {
				this.customerSatisfaction = [] as any;
				for (let item of _data["customerSatisfaction"])
					this.customerSatisfaction!.push(SeriesDtoOfDecimal.fromJS(item));
			}
		}
	}

	static fromJS(data: any): ReporteSatisfaccionDto {
		data = typeof data === 'object' ? data : {};
		let result = new ReporteSatisfaccionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.generalSatisfaction)) {
			data["generalSatisfaction"] = [];
			for (let item of this.generalSatisfaction)
				data["generalSatisfaction"].push(item.toJSON());
		}
		if (Array.isArray(this.customerSatisfaction)) {
			data["customerSatisfaction"] = [];
			for (let item of this.customerSatisfaction)
				data["customerSatisfaction"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IReporteSatisfaccionDto extends IBaseReporteDto {
	generalSatisfaction?: SeriesDtoOfDecimal[] | undefined;
	customerSatisfaction?: SeriesDtoOfDecimal[] | undefined;
}

export class ReporteEstablecimientoDto extends BaseReporteDto implements IReporteEstablecimientoDto {
	totalEntregas!: number;
	entregaFormularioNivelAtencion?: SeriesDtoOfLong[] | undefined;
	cantidadEntregaFormulario?: DoughnutChartDtoOfLong | undefined;

	constructor(data?: IReporteEstablecimientoDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.totalEntregas = _data["totalEntregas"];
			if (Array.isArray(_data["entregaFormularioNivelAtencion"])) {
				this.entregaFormularioNivelAtencion = [] as any;
				for (let item of _data["entregaFormularioNivelAtencion"])
					this.entregaFormularioNivelAtencion!.push(SeriesDtoOfLong.fromJS(item));
			}
			this.cantidadEntregaFormulario = _data["cantidadEntregaFormulario"] ? DoughnutChartDtoOfLong.fromJS(_data["cantidadEntregaFormulario"]) : <any>undefined;
		}
	}

	static fromJS(data: any): ReporteEstablecimientoDto {
		data = typeof data === 'object' ? data : {};
		let result = new ReporteEstablecimientoDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["totalEntregas"] = this.totalEntregas;
		if (Array.isArray(this.entregaFormularioNivelAtencion)) {
			data["entregaFormularioNivelAtencion"] = [];
			for (let item of this.entregaFormularioNivelAtencion)
				data["entregaFormularioNivelAtencion"].push(item.toJSON());
		}
		data["cantidadEntregaFormulario"] = this.cantidadEntregaFormulario ? this.cantidadEntregaFormulario.toJSON() : <any>undefined;
		super.toJSON(data);
		return data;
	}
}

export interface IReporteEstablecimientoDto extends IBaseReporteDto {
	totalEntregas: number;
	entregaFormularioNivelAtencion?: SeriesDtoOfLong[] | undefined;
	cantidadEntregaFormulario?: DoughnutChartDtoOfLong | undefined;
}

export class DoughnutChartDtoOfLong implements IDoughnutChartDtoOfLong {
	data?: number[] | undefined;
	labels?: string[] | undefined;

	constructor(data?: IDoughnutChartDtoOfLong) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["data"])) {
				this.data = [] as any;
				for (let item of _data["data"])
					this.data!.push(item);
			}
			if (Array.isArray(_data["labels"])) {
				this.labels = [] as any;
				for (let item of _data["labels"])
					this.labels!.push(item);
			}
		}
	}

	static fromJS(data: any): DoughnutChartDtoOfLong {
		data = typeof data === 'object' ? data : {};
		let result = new DoughnutChartDtoOfLong();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.data)) {
			data["data"] = [];
			for (let item of this.data)
				data["data"].push(item);
		}
		if (Array.isArray(this.labels)) {
			data["labels"] = [];
			for (let item of this.labels)
				data["labels"].push(item);
		}
		return data;
	}
}

export interface IDoughnutChartDtoOfLong {
	data?: number[] | undefined;
	labels?: string[] | undefined;
}

export class ReporteFormularioDto implements IReporteFormularioDto {
	porcentajeRespuesta?: DoughnutChartDtoOfDecimal | undefined;
	promedioRespuesta!: number;
	respuestaMasFrecuente?: string | undefined;
	filters?: { [key: string]: any; } | undefined;

	constructor(data?: IReporteFormularioDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.porcentajeRespuesta = _data["porcentajeRespuesta"] ? DoughnutChartDtoOfDecimal.fromJS(_data["porcentajeRespuesta"]) : <any>undefined;
			this.promedioRespuesta = _data["promedioRespuesta"];
			this.respuestaMasFrecuente = _data["respuestaMasFrecuente"];
			if (_data["filters"]) {
				this.filters = {} as any;
				for (let key in _data["filters"]) {
					if (_data["filters"].hasOwnProperty(key))
						this.filters![key] = _data["filters"][key];
				}
			}
		}
	}

	static fromJS(data: any): ReporteFormularioDto {
		data = typeof data === 'object' ? data : {};
		let result = new ReporteFormularioDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["porcentajeRespuesta"] = this.porcentajeRespuesta ? this.porcentajeRespuesta.toJSON() : <any>undefined;
		data["promedioRespuesta"] = this.promedioRespuesta;
		data["respuestaMasFrecuente"] = this.respuestaMasFrecuente;
		if (this.filters) {
			data["filters"] = {};
			for (let key in this.filters) {
				if (this.filters.hasOwnProperty(key))
					data["filters"][key] = this.filters[key];
			}
		}
		return data;
	}
}

export interface IReporteFormularioDto {
	porcentajeRespuesta?: DoughnutChartDtoOfDecimal | undefined;
	promedioRespuesta: number;
	respuestaMasFrecuente?: string | undefined;
	filters?: { [key: string]: any; } | undefined;
}

export class DoughnutChartDtoOfDecimal implements IDoughnutChartDtoOfDecimal {
	data?: number[] | undefined;
	labels?: string[] | undefined;

	constructor(data?: IDoughnutChartDtoOfDecimal) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["data"])) {
				this.data = [] as any;
				for (let item of _data["data"])
					this.data!.push(item);
			}
			if (Array.isArray(_data["labels"])) {
				this.labels = [] as any;
				for (let item of _data["labels"])
					this.labels!.push(item);
			}
		}
	}

	static fromJS(data: any): DoughnutChartDtoOfDecimal {
		data = typeof data === 'object' ? data : {};
		let result = new DoughnutChartDtoOfDecimal();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.data)) {
			data["data"] = [];
			for (let item of this.data)
				data["data"].push(item);
		}
		if (Array.isArray(this.labels)) {
			data["labels"] = [];
			for (let item of this.labels)
				data["labels"].push(item);
		}
		return data;
	}
}

export interface IDoughnutChartDtoOfDecimal {
	data?: number[] | undefined;
	labels?: string[] | undefined;
}

export class ReporteOptionDto implements IReporteOptionDto {
	formulario?: GenericItemDto[] | undefined;
	month?: GenericItemDto[] | undefined;
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	pregunta?: GenericItemDto[] | undefined;
	regionSalud?: EnumDtoOfRegionSalud[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;
	year?: GenericItemDto[] | undefined;
	usuario?: GenericItemDtoOfGuid[] | undefined;

	constructor(data?: IReporteOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["formulario"])) {
				this.formulario = [] as any;
				for (let item of _data["formulario"])
					this.formulario!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["month"])) {
				this.month = [] as any;
				for (let item of _data["month"])
					this.month!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["nivelAtencion"])) {
				this.nivelAtencion = [] as any;
				for (let item of _data["nivelAtencion"])
					this.nivelAtencion!.push(EnumDtoOfNivelAtencion.fromJS(item));
			}
			if (Array.isArray(_data["pregunta"])) {
				this.pregunta = [] as any;
				for (let item of _data["pregunta"])
					this.pregunta!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["regionSalud"])) {
				this.regionSalud = [] as any;
				for (let item of _data["regionSalud"])
					this.regionSalud!.push(EnumDtoOfRegionSalud.fromJS(item));
			}
			if (Array.isArray(_data["tipoSolicitud"])) {
				this.tipoSolicitud = [] as any;
				for (let item of _data["tipoSolicitud"])
					this.tipoSolicitud!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["tipoServicio"])) {
				this.tipoServicio = [] as any;
				for (let item of _data["tipoServicio"])
					this.tipoServicio!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["year"])) {
				this.year = [] as any;
				for (let item of _data["year"])
					this.year!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["usuario"])) {
				this.usuario = [] as any;
				for (let item of _data["usuario"])
					this.usuario!.push(GenericItemDtoOfGuid.fromJS(item));
			}
		}
	}

	static fromJS(data: any): ReporteOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new ReporteOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.formulario)) {
			data["formulario"] = [];
			for (let item of this.formulario)
				data["formulario"].push(item.toJSON());
		}
		if (Array.isArray(this.month)) {
			data["month"] = [];
			for (let item of this.month)
				data["month"].push(item.toJSON());
		}
		if (Array.isArray(this.nivelAtencion)) {
			data["nivelAtencion"] = [];
			for (let item of this.nivelAtencion)
				data["nivelAtencion"].push(item.toJSON());
		}
		if (Array.isArray(this.pregunta)) {
			data["pregunta"] = [];
			for (let item of this.pregunta)
				data["pregunta"].push(item.toJSON());
		}
		if (Array.isArray(this.regionSalud)) {
			data["regionSalud"] = [];
			for (let item of this.regionSalud)
				data["regionSalud"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoSolicitud)) {
			data["tipoSolicitud"] = [];
			for (let item of this.tipoSolicitud)
				data["tipoSolicitud"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoServicio)) {
			data["tipoServicio"] = [];
			for (let item of this.tipoServicio)
				data["tipoServicio"].push(item.toJSON());
		}
		if (Array.isArray(this.year)) {
			data["year"] = [];
			for (let item of this.year)
				data["year"].push(item.toJSON());
		}
		if (Array.isArray(this.usuario)) {
			data["usuario"] = [];
			for (let item of this.usuario)
				data["usuario"].push(item.toJSON());
		}
		return data;
	}
}

export interface IReporteOptionDto {
	formulario?: GenericItemDto[] | undefined;
	month?: GenericItemDto[] | undefined;
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	pregunta?: GenericItemDto[] | undefined;
	regionSalud?: EnumDtoOfRegionSalud[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;
	year?: GenericItemDto[] | undefined;
	usuario?: GenericItemDtoOfGuid[] | undefined;
}

export class PagedResultOfRespuestaExtendedDto extends PagedResultBase implements IPagedResultOfRespuestaExtendedDto {
	results?: RespuestaExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfRespuestaExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(RespuestaExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfRespuestaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfRespuestaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfRespuestaExtendedDto extends IPagedResultBase {
	results?: RespuestaExtendedDto[] | undefined;
}

export class RespuestaDto implements IRespuestaDto {
	id!: number;
	fecha!: Date;

	constructor(data?: IRespuestaDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.fecha = _data["fecha"] ? new Date(_data["fecha"].toString()) : <any>undefined;
		}
	}

	static fromJS(data: any): RespuestaDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["fecha"] = this.fecha ? this.fecha.toISOString() : <any>undefined;
		return data;
	}
}

export interface IRespuestaDto {
	id: number;
	fecha: Date;
}

export class RespuestaExtendedDto extends RespuestaDto implements IRespuestaExtendedDto {
	formulario?: FormularioExtendedNoCollectionsDto | undefined;
	establecimiento?: EstablecimientoExtendedDto | undefined;
	datosEncuestado?: DatosEncuestadoExtendedDto | undefined;
	casoResuelto!: boolean;
	respuestaPregunta?: RespuestaPreguntaExtendedDto[] | undefined;
	seguimientoRespuesta?: SeguimientoRespuestaExtendedDto[] | undefined;
	usuario?: UsuarioExtendedDto | undefined;

	constructor(data?: IRespuestaExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.formulario = _data["formulario"] ? FormularioExtendedNoCollectionsDto.fromJS(_data["formulario"]) : <any>undefined;
			this.establecimiento = _data["establecimiento"] ? EstablecimientoExtendedDto.fromJS(_data["establecimiento"]) : <any>undefined;
			this.datosEncuestado = _data["datosEncuestado"] ? DatosEncuestadoExtendedDto.fromJS(_data["datosEncuestado"]) : <any>undefined;
			this.casoResuelto = _data["casoResuelto"];
			if (Array.isArray(_data["respuestaPregunta"])) {
				this.respuestaPregunta = [] as any;
				for (let item of _data["respuestaPregunta"])
					this.respuestaPregunta!.push(RespuestaPreguntaExtendedDto.fromJS(item));
			}
			if (Array.isArray(_data["seguimientoRespuesta"])) {
				this.seguimientoRespuesta = [] as any;
				for (let item of _data["seguimientoRespuesta"])
					this.seguimientoRespuesta!.push(SeguimientoRespuestaExtendedDto.fromJS(item));
			}
			this.usuario = _data["usuario"] ? UsuarioExtendedDto.fromJS(_data["usuario"]) : <any>undefined;
		}
	}

	static fromJS(data: any): RespuestaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["formulario"] = this.formulario ? this.formulario.toJSON() : <any>undefined;
		data["establecimiento"] = this.establecimiento ? this.establecimiento.toJSON() : <any>undefined;
		data["datosEncuestado"] = this.datosEncuestado ? this.datosEncuestado.toJSON() : <any>undefined;
		data["casoResuelto"] = this.casoResuelto;
		if (Array.isArray(this.respuestaPregunta)) {
			data["respuestaPregunta"] = [];
			for (let item of this.respuestaPregunta)
				data["respuestaPregunta"].push(item.toJSON());
		}
		if (Array.isArray(this.seguimientoRespuesta)) {
			data["seguimientoRespuesta"] = [];
			for (let item of this.seguimientoRespuesta)
				data["seguimientoRespuesta"].push(item.toJSON());
		}
		data["usuario"] = this.usuario ? this.usuario.toJSON() : <any>undefined;
		super.toJSON(data);
		return data;
	}
}

export interface IRespuestaExtendedDto extends IRespuestaDto {
	formulario?: FormularioExtendedNoCollectionsDto | undefined;
	establecimiento?: EstablecimientoExtendedDto | undefined;
	datosEncuestado?: DatosEncuestadoExtendedDto | undefined;
	casoResuelto: boolean;
	respuestaPregunta?: RespuestaPreguntaExtendedDto[] | undefined;
	seguimientoRespuesta?: SeguimientoRespuestaExtendedDto[] | undefined;
	usuario?: UsuarioExtendedDto | undefined;
}

export class DatosEncuestadoExtendedDto implements IDatosEncuestadoExtendedDto {
	id!: number;
	respuestaId!: number;
	tipoDocumentoIdentidad?: string | undefined;
	documentoIdentidad?: string | undefined;
	nombre?: string | undefined;
	apellido?: string | undefined;
	correoElectronico?: string | undefined;
	telefono?: string | undefined;
	sexo?: string | undefined;
	fechaNacimiento!: Date;

	constructor(data?: IDatosEncuestadoExtendedDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.respuestaId = _data["respuestaId"];
			this.tipoDocumentoIdentidad = _data["tipoDocumentoIdentidad"];
			this.documentoIdentidad = _data["documentoIdentidad"];
			this.nombre = _data["nombre"];
			this.apellido = _data["apellido"];
			this.correoElectronico = _data["correoElectronico"];
			this.telefono = _data["telefono"];
			this.sexo = _data["sexo"];
			this.fechaNacimiento = _data["fechaNacimiento"] ? new Date(_data["fechaNacimiento"].toString()) : <any>undefined;
		}
	}

	static fromJS(data: any): DatosEncuestadoExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new DatosEncuestadoExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["respuestaId"] = this.respuestaId;
		data["tipoDocumentoIdentidad"] = this.tipoDocumentoIdentidad;
		data["documentoIdentidad"] = this.documentoIdentidad;
		data["nombre"] = this.nombre;
		data["apellido"] = this.apellido;
		data["correoElectronico"] = this.correoElectronico;
		data["telefono"] = this.telefono;
		data["sexo"] = this.sexo;
		data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
		return data;
	}
}

export interface IDatosEncuestadoExtendedDto {
	id: number;
	respuestaId: number;
	tipoDocumentoIdentidad?: string | undefined;
	documentoIdentidad?: string | undefined;
	nombre?: string | undefined;
	apellido?: string | undefined;
	correoElectronico?: string | undefined;
	telefono?: string | undefined;
	sexo?: string | undefined;
	fechaNacimiento: Date;
}

export class RespuestaPreguntaExtendedDto implements IRespuestaPreguntaExtendedDto {
	id!: number;
	contestacion?: string | undefined;
	tipoRespuestaPregunta!: TipoRespuestaPregunta;
	tipoRespuestaPreguntaString?: string | undefined;
	pregunta?: PreguntaExtendedNoCollectionsDto | undefined;
	opciones?: OpcionDto[] | undefined;

	constructor(data?: IRespuestaPreguntaExtendedDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.contestacion = _data["contestacion"];
			this.tipoRespuestaPregunta = _data["tipoRespuestaPregunta"];
			this.tipoRespuestaPreguntaString = _data["tipoRespuestaPreguntaString"];
			this.pregunta = _data["pregunta"] ? PreguntaExtendedNoCollectionsDto.fromJS(_data["pregunta"]) : <any>undefined;
			if (Array.isArray(_data["opciones"])) {
				this.opciones = [] as any;
				for (let item of _data["opciones"])
					this.opciones!.push(OpcionDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): RespuestaPreguntaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaPreguntaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["contestacion"] = this.contestacion;
		data["tipoRespuestaPregunta"] = this.tipoRespuestaPregunta;
		data["tipoRespuestaPreguntaString"] = this.tipoRespuestaPreguntaString;
		data["pregunta"] = this.pregunta ? this.pregunta.toJSON() : <any>undefined;
		if (Array.isArray(this.opciones)) {
			data["opciones"] = [];
			for (let item of this.opciones)
				data["opciones"].push(item.toJSON());
		}
		return data;
	}
}

export interface IRespuestaPreguntaExtendedDto {
	id: number;
	contestacion?: string | undefined;
	tipoRespuestaPregunta: TipoRespuestaPregunta;
	tipoRespuestaPreguntaString?: string | undefined;
	pregunta?: PreguntaExtendedNoCollectionsDto | undefined;
	opciones?: OpcionDto[] | undefined;
}

export enum TipoRespuestaPregunta {
	RespuestaUnica = 1,
	RespuestaMultiple = 2,
	RespuestaAbierta = 3,
	RespuestaUnicaOAbierta = 4,
	RespuestaMultipleOAbierta = 5,
}

export class SeguimientoRespuestaExtendedDto implements ISeguimientoRespuestaExtendedDto {
	id!: number;
	respuestaId!: number;
	usuarioId!: string;
	seTomoAlgunaAccion!: boolean;
	accionTomada?: AccionTomada | undefined;
	accionTomadaOtra?: string | undefined;
	fecha?: string | undefined;
	explicacionNoSeTomoAccion?: string | undefined;
	usuario?: UsuarioDto | undefined;

	constructor(data?: ISeguimientoRespuestaExtendedDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.respuestaId = _data["respuestaId"];
			this.usuarioId = _data["usuarioId"];
			this.seTomoAlgunaAccion = _data["seTomoAlgunaAccion"];
			this.accionTomada = _data["accionTomada"];
			this.accionTomadaOtra = _data["accionTomadaOtra"];
			this.fecha = _data["fecha"];
			this.explicacionNoSeTomoAccion = _data["explicacionNoSeTomoAccion"];
			this.usuario = _data["usuario"] ? UsuarioDto.fromJS(_data["usuario"]) : <any>undefined;
		}
	}

	static fromJS(data: any): SeguimientoRespuestaExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new SeguimientoRespuestaExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["respuestaId"] = this.respuestaId;
		data["usuarioId"] = this.usuarioId;
		data["seTomoAlgunaAccion"] = this.seTomoAlgunaAccion;
		data["accionTomada"] = this.accionTomada;
		data["accionTomadaOtra"] = this.accionTomadaOtra;
		data["fecha"] = this.fecha;
		data["explicacionNoSeTomoAccion"] = this.explicacionNoSeTomoAccion;
		data["usuario"] = this.usuario ? this.usuario.toJSON() : <any>undefined;
		return data;
	}
}

export interface ISeguimientoRespuestaExtendedDto {
	id: number;
	respuestaId: number;
	usuarioId: string;
	seTomoAlgunaAccion: boolean;
	accionTomada?: AccionTomada | undefined;
	accionTomadaOtra?: string | undefined;
	fecha?: string | undefined;
	explicacionNoSeTomoAccion?: string | undefined;
	usuario?: UsuarioDto | undefined;
}

export enum AccionTomada {
	Disculpa = 1,
	AcciónDisciplinaria = 2,
	Explicación = 3,
	Reembolso = 4,
	CambioDeProceso = 5,
	Otra = 6,
}

export class RespuestaFlatDto extends RespuestaDto implements IRespuestaFlatDto {
	establecimientoId!: number;
	formularioId!: number;
	tipoDocumentoIdentidad!: TipoDocumentoIdentidad;
	documentoIdentidad?: string | undefined;
	nombre?: string | undefined;
	apellido?: string | undefined;
	correoElectronico?: string | undefined;
	telefono?: string | undefined;
	sexo!: Sexo;
	fechaNacimiento!: Date;
	respuestasPreguntas?: RespuestaPreguntaDto[] | undefined;

	constructor(data?: IRespuestaFlatDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.establecimientoId = _data["establecimientoId"];
			this.formularioId = _data["formularioId"];
			this.tipoDocumentoIdentidad = _data["tipoDocumentoIdentidad"];
			this.documentoIdentidad = _data["documentoIdentidad"];
			this.nombre = _data["nombre"];
			this.apellido = _data["apellido"];
			this.correoElectronico = _data["correoElectronico"];
			this.telefono = _data["telefono"];
			this.sexo = _data["sexo"];
			this.fechaNacimiento = _data["fechaNacimiento"] ? new Date(_data["fechaNacimiento"].toString()) : <any>undefined;
			if (Array.isArray(_data["respuestasPreguntas"])) {
				this.respuestasPreguntas = [] as any;
				for (let item of _data["respuestasPreguntas"])
					this.respuestasPreguntas!.push(RespuestaPreguntaDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): RespuestaFlatDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaFlatDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["establecimientoId"] = this.establecimientoId;
		data["formularioId"] = this.formularioId;
		data["tipoDocumentoIdentidad"] = this.tipoDocumentoIdentidad;
		data["documentoIdentidad"] = this.documentoIdentidad;
		data["nombre"] = this.nombre;
		data["apellido"] = this.apellido;
		data["correoElectronico"] = this.correoElectronico;
		data["telefono"] = this.telefono;
		data["sexo"] = this.sexo;
		data["fechaNacimiento"] = this.fechaNacimiento ? this.fechaNacimiento.toISOString() : <any>undefined;
		if (Array.isArray(this.respuestasPreguntas)) {
			data["respuestasPreguntas"] = [];
			for (let item of this.respuestasPreguntas)
				data["respuestasPreguntas"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IRespuestaFlatDto extends IRespuestaDto {
	establecimientoId: number;
	formularioId: number;
	tipoDocumentoIdentidad: TipoDocumentoIdentidad;
	documentoIdentidad?: string | undefined;
	nombre?: string | undefined;
	apellido?: string | undefined;
	correoElectronico?: string | undefined;
	telefono?: string | undefined;
	sexo: Sexo;
	fechaNacimiento: Date;
	respuestasPreguntas?: RespuestaPreguntaDto[] | undefined;
}

export enum TipoDocumentoIdentidad {
	Cedula = 1,
	Pasaporte = 2,
}

export enum Sexo {
	Masculino = 1,
	Femenino = 2,
}

export class RespuestaPreguntaDto implements IRespuestaPreguntaDto {
	id!: number;
	preguntaId!: number;
	contestacion?: string | undefined;
	opciones?: number[] | undefined;

	constructor(data?: IRespuestaPreguntaDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.preguntaId = _data["preguntaId"];
			this.contestacion = _data["contestacion"];
			if (Array.isArray(_data["opciones"])) {
				this.opciones = [] as any;
				for (let item of _data["opciones"])
					this.opciones!.push(item);
			}
		}
	}

	static fromJS(data: any): RespuestaPreguntaDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaPreguntaDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["preguntaId"] = this.preguntaId;
		data["contestacion"] = this.contestacion;
		if (Array.isArray(this.opciones)) {
			data["opciones"] = [];
			for (let item of this.opciones)
				data["opciones"].push(item);
		}
		return data;
	}
}

export interface IRespuestaPreguntaDto {
	id: number;
	preguntaId: number;
	contestacion?: string | undefined;
	opciones?: number[] | undefined;
}

export class SeguimientoRespuestaDto implements ISeguimientoRespuestaDto {
	seTomoAlgunaAccion!: boolean;
	accionTomada!: AccionTomada;
	accionTomadaOtra?: string | undefined;
	explicacionNoSeTomoAccion?: string | undefined;
	casoResuelto!: boolean;
	fecha?: string | undefined;

	constructor(data?: ISeguimientoRespuestaDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.seTomoAlgunaAccion = _data["seTomoAlgunaAccion"];
			this.accionTomada = _data["accionTomada"];
			this.accionTomadaOtra = _data["accionTomadaOtra"];
			this.explicacionNoSeTomoAccion = _data["explicacionNoSeTomoAccion"];
			this.casoResuelto = _data["casoResuelto"];
			this.fecha = _data["fecha"];
		}
	}

	static fromJS(data: any): SeguimientoRespuestaDto {
		data = typeof data === 'object' ? data : {};
		let result = new SeguimientoRespuestaDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["seTomoAlgunaAccion"] = this.seTomoAlgunaAccion;
		data["accionTomada"] = this.accionTomada;
		data["accionTomadaOtra"] = this.accionTomadaOtra;
		data["explicacionNoSeTomoAccion"] = this.explicacionNoSeTomoAccion;
		data["casoResuelto"] = this.casoResuelto;
		data["fecha"] = this.fecha;
		return data;
	}
}

export interface ISeguimientoRespuestaDto {
	seTomoAlgunaAccion: boolean;
	accionTomada: AccionTomada;
	accionTomadaOtra?: string | undefined;
	explicacionNoSeTomoAccion?: string | undefined;
	casoResuelto: boolean;
	fecha?: string | undefined;
}

export class RespuestaOptionDto implements IRespuestaOptionDto {
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	regionSalud?: EnumDtoOfRegionSalud[] | undefined;
	formulario?: FormularioItemDto[] | undefined;
	provincia?: ProvinciaDto[] | undefined;
	usuario?: GenericItemDtoOfGuid[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;

	constructor(data?: IRespuestaOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["nivelAtencion"])) {
				this.nivelAtencion = [] as any;
				for (let item of _data["nivelAtencion"])
					this.nivelAtencion!.push(EnumDtoOfNivelAtencion.fromJS(item));
			}
			if (Array.isArray(_data["regionSalud"])) {
				this.regionSalud = [] as any;
				for (let item of _data["regionSalud"])
					this.regionSalud!.push(EnumDtoOfRegionSalud.fromJS(item));
			}
			if (Array.isArray(_data["formulario"])) {
				this.formulario = [] as any;
				for (let item of _data["formulario"])
					this.formulario!.push(FormularioItemDto.fromJS(item));
			}
			if (Array.isArray(_data["provincia"])) {
				this.provincia = [] as any;
				for (let item of _data["provincia"])
					this.provincia!.push(ProvinciaDto.fromJS(item));
			}
			if (Array.isArray(_data["usuario"])) {
				this.usuario = [] as any;
				for (let item of _data["usuario"])
					this.usuario!.push(GenericItemDtoOfGuid.fromJS(item));
			}
			if (Array.isArray(_data["tipoSolicitud"])) {
				this.tipoSolicitud = [] as any;
				for (let item of _data["tipoSolicitud"])
					this.tipoSolicitud!.push(GenericItemDto.fromJS(item));
			}
			if (Array.isArray(_data["tipoServicio"])) {
				this.tipoServicio = [] as any;
				for (let item of _data["tipoServicio"])
					this.tipoServicio!.push(GenericItemDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): RespuestaOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new RespuestaOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.nivelAtencion)) {
			data["nivelAtencion"] = [];
			for (let item of this.nivelAtencion)
				data["nivelAtencion"].push(item.toJSON());
		}
		if (Array.isArray(this.regionSalud)) {
			data["regionSalud"] = [];
			for (let item of this.regionSalud)
				data["regionSalud"].push(item.toJSON());
		}
		if (Array.isArray(this.formulario)) {
			data["formulario"] = [];
			for (let item of this.formulario)
				data["formulario"].push(item.toJSON());
		}
		if (Array.isArray(this.provincia)) {
			data["provincia"] = [];
			for (let item of this.provincia)
				data["provincia"].push(item.toJSON());
		}
		if (Array.isArray(this.usuario)) {
			data["usuario"] = [];
			for (let item of this.usuario)
				data["usuario"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoSolicitud)) {
			data["tipoSolicitud"] = [];
			for (let item of this.tipoSolicitud)
				data["tipoSolicitud"].push(item.toJSON());
		}
		if (Array.isArray(this.tipoServicio)) {
			data["tipoServicio"] = [];
			for (let item of this.tipoServicio)
				data["tipoServicio"].push(item.toJSON());
		}
		return data;
	}
}

export interface IRespuestaOptionDto {
	nivelAtencion?: EnumDtoOfNivelAtencion[] | undefined;
	regionSalud?: EnumDtoOfRegionSalud[] | undefined;
	formulario?: FormularioItemDto[] | undefined;
	provincia?: ProvinciaDto[] | undefined;
	usuario?: GenericItemDtoOfGuid[] | undefined;
	tipoSolicitud?: GenericItemDto[] | undefined;
	tipoServicio?: GenericItemDto[] | undefined;
}

export class FormularioItemDto extends GenericItemDto implements IFormularioItemDto {
	showTipoServicio!: boolean;
	showTipoSolicitud!: boolean;
	showCasoResuelto!: boolean;

	constructor(data?: IFormularioItemDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.showTipoServicio = _data["showTipoServicio"];
			this.showTipoSolicitud = _data["showTipoSolicitud"];
			this.showCasoResuelto = _data["showCasoResuelto"];
		}
	}

	static fromJS(data: any): FormularioItemDto {
		data = typeof data === 'object' ? data : {};
		let result = new FormularioItemDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["showTipoServicio"] = this.showTipoServicio;
		data["showTipoSolicitud"] = this.showTipoSolicitud;
		data["showCasoResuelto"] = this.showCasoResuelto;
		super.toJSON(data);
		return data;
	}
}

export interface IFormularioItemDto extends IGenericItemDto {
	showTipoServicio: boolean;
	showTipoSolicitud: boolean;
	showCasoResuelto: boolean;
}

export class PagedResultOfRolCountDto extends PagedResultBase implements IPagedResultOfRolCountDto {
	results?: RolCountDto[] | undefined;

	constructor(data?: IPagedResultOfRolCountDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(RolCountDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfRolCountDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfRolCountDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfRolCountDto extends IPagedResultBase {
	results?: RolCountDto[] | undefined;
}

export class RolCountDto extends RolDto implements IRolCountDto {
	count!: number;

	constructor(data?: IRolCountDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.count = _data["count"];
		}
	}

	static fromJS(data: any): RolCountDto {
		data = typeof data === 'object' ? data : {};
		let result = new RolCountDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["count"] = this.count;
		super.toJSON(data);
		return data;
	}
}

export interface IRolCountDto extends IRolDto {
	count: number;
}

export class PagedResultOfUsuarioExtendedDto extends PagedResultBase implements IPagedResultOfUsuarioExtendedDto {
	results?: UsuarioExtendedDto[] | undefined;

	constructor(data?: IPagedResultOfUsuarioExtendedDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			if (Array.isArray(_data["results"])) {
				this.results = [] as any;
				for (let item of _data["results"])
					this.results!.push(UsuarioExtendedDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): PagedResultOfUsuarioExtendedDto {
		data = typeof data === 'object' ? data : {};
		let result = new PagedResultOfUsuarioExtendedDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.results)) {
			data["results"] = [];
			for (let item of this.results)
				data["results"].push(item.toJSON());
		}
		super.toJSON(data);
		return data;
	}
}

export interface IPagedResultOfUsuarioExtendedDto extends IPagedResultBase {
	results?: UsuarioExtendedDto[] | undefined;
}

export class UsuarioOptionDto implements IUsuarioOptionDto {
	regionSalud?: RegionSaludDto[] | undefined;
	establecimiento?: EstablecimientoItemDto[] | undefined;
	rol?: RolDto[] | undefined;

	constructor(data?: IUsuarioOptionDto) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			if (Array.isArray(_data["regionSalud"])) {
				this.regionSalud = [] as any;
				for (let item of _data["regionSalud"])
					this.regionSalud!.push(RegionSaludDto.fromJS(item));
			}
			if (Array.isArray(_data["establecimiento"])) {
				this.establecimiento = [] as any;
				for (let item of _data["establecimiento"])
					this.establecimiento!.push(EstablecimientoItemDto.fromJS(item));
			}
			if (Array.isArray(_data["rol"])) {
				this.rol = [] as any;
				for (let item of _data["rol"])
					this.rol!.push(RolDto.fromJS(item));
			}
		}
	}

	static fromJS(data: any): UsuarioOptionDto {
		data = typeof data === 'object' ? data : {};
		let result = new UsuarioOptionDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		if (Array.isArray(this.regionSalud)) {
			data["regionSalud"] = [];
			for (let item of this.regionSalud)
				data["regionSalud"].push(item.toJSON());
		}
		if (Array.isArray(this.establecimiento)) {
			data["establecimiento"] = [];
			for (let item of this.establecimiento)
				data["establecimiento"].push(item.toJSON());
		}
		if (Array.isArray(this.rol)) {
			data["rol"] = [];
			for (let item of this.rol)
				data["rol"].push(item.toJSON());
		}
		return data;
	}
}

export interface IUsuarioOptionDto {
	regionSalud?: RegionSaludDto[] | undefined;
	establecimiento?: EstablecimientoItemDto[] | undefined;
	rol?: RolDto[] | undefined;
}

export class GenericItemDtoOfLong implements IGenericItemDtoOfLong {
	id!: number;
	name?: string | undefined;

	constructor(data?: IGenericItemDtoOfLong) {
		if (data) {
			for (var property in data) {
				if (data.hasOwnProperty(property))
					(<any>this)[property] = (<any>data)[property];
			}
		}
	}

	init(_data?: any) {
		if (_data) {
			this.id = _data["id"];
			this.name = _data["name"];
		}
	}

	static fromJS(data: any): GenericItemDtoOfLong {
		data = typeof data === 'object' ? data : {};
		let result = new GenericItemDtoOfLong();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["id"] = this.id;
		data["name"] = this.name;
		return data;
	}
}

export interface IGenericItemDtoOfLong {
	id: number;
	name?: string | undefined;
}

export class EstablecimientoItemDto extends GenericItemDtoOfLong implements IEstablecimientoItemDto {
	gerenciaAreaSalud!: GerenciaAreaSalud;

	constructor(data?: IEstablecimientoItemDto) {
		super(data);
	}

	init(_data?: any) {
		super.init(_data);
		if (_data) {
			this.gerenciaAreaSalud = _data["gerenciaAreaSalud"];
		}
	}

	static fromJS(data: any): EstablecimientoItemDto {
		data = typeof data === 'object' ? data : {};
		let result = new EstablecimientoItemDto();
		result.init(data);
		return result;
	}

	toJSON(data?: any) {
		data = typeof data === 'object' ? data : {};
		data["gerenciaAreaSalud"] = this.gerenciaAreaSalud;
		super.toJSON(data);
		return data;
	}
}

export interface IEstablecimientoItemDto extends IGenericItemDtoOfLong {
	gerenciaAreaSalud: GerenciaAreaSalud;
}

export class ApiException extends Error {
	message: string;
	status: number;
	response: string;
	headers: { [key: string]: any; };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isApiException = true;

	static isApiException(obj: any): obj is ApiException {
		return obj.isApiException === true;
	}
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
	if (result !== null && result !== undefined)
		return _observableThrow(result);
	else
		return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
	return new Observable<string>((observer: any) => {
		if (!blob) {
			observer.next("");
			observer.complete();
		} else {
			let reader = new FileReader();
			reader.onload = event => {
				observer.next((<any>event.target).result);
				observer.complete();
			};
			reader.readAsText(blob);
		}
	});
}